/*==============================================================================
  
THEME.JS
  
  #SLATE ........................................ Shopify helpers and utilities based on Shopify Slate

  slate.a11y .................................... Accessibility helpers
  slate.utils ................................... Utility helpers for dealing with arrays and objects. Customised to add helpers for linked product options
  slate.rte ..................................... Rich Text Editor helpers 
  theme.Sections ................................ Custom Sections functionality based on Slate with minor adjustments
  slate.Currency ................................ Currency helpers
  slate.Image ................................... Image helpers
  slate.Variants ................................ Variant selection event triggers. Modified to add more events.


  #CONFIG & UTILITIES ........................... General config and utilities

  theme.config .................................. General config for breakpoints, touch devices, etc.
  theme.mq ...................................... Media queries matching our CSS
  theme.setBreakpoints .......................... Event listeners to set breakpoints based on Enquire JS in vendor.js
  theme.CartUtilities ........................... AJAX Shopify Cart API utilities
  theme.AjaxProduct ............................. AJAX Add Product Functionality
  theme.loadImageSection ........................ Allows for adding classes whilst loading so we can animate


  #MODULES ...................................... General modules

  theme.CustomSwitcher .......................... Custom dropdown elements
  theme.HeaderNav ............................... Header Dropdown functionality using click. UNUSED.
  theme.HeaderNavTouch .......................... Header Dropdown functionality using hover with extra code to support touch devices.
  theme.Modals .................................. Modals functionality
  theme.Drawers ................................. Drawers functionality
  theme.DrawerPanels ............................ Module to extend drawers functionality to show panels
  theme.Collapsibles ............................ Collapsibles functionality
  theme.Tabs .................................... Tabs functionality
  theme.Search .................................. AJAX search functionality
  theme.HeaderSearch ............................ Controls header search dropdown
  theme.StickyProductForm ....................... PDP Sticky Add to Cart Form
  theme.toggleHamper ............................ Functionality to show/hide hamper products on PDP


  #SECTIONS ..................................... Shopify Sections

  theme.HeaderSection ........................... Header section including Announcement Bar
  theme.PopupSection ............................ Popup section
  theme.CookiesSection .......................... Cookies section
  theme.Cart .................................... Handles major cart functionality on cart page and AJAX cart drawer
  theme.Product ................................. Major Product functionality
  theme.ProductRecommendations .................. Product Recommendations functionality based on Shopify recommendations engine
  theme.CollectionSection ....................... PLP functionality including filters
  theme.SearchSection ........................... Search Page functionality
  theme.SlideshowSection ........................ Slideshow based on Flickity in vendor.js
  theme.ExperiencesSection ...................... Homepage Experiences section that uses Flickity slideshow
  theme.FeaturedProductsSection ................. Homepage Featured Products section that uses Flickity slideshow
  theme.FaqSection .............................. FAQ / Delivery pages using Collapsibles functionality


  #TEMPLATES .................................... Functionality specific to Shopify Templates

  theme.customerAddresses ....................... Customer Address form functionality
  theme.customerLogin ........................... Customer Login page functionality


  #INIT ......................................... Main init to run various modules and uncategorised code including tab handling for accessibility

  - Tab handling to maintain accessibility
  - Smooth Scrolling for in-page anchor links
  - theme.setBreakpoints();
  - theme.DrawerPanels.init()
  - theme.Cart.init();
  - theme.Modals.init();
  - theme.Collapsibles.init();
  - theme.CustomSwitcher();

  - Initialise PLYR custom video styling extension


  #DOC READY .................................... Document Ready functions
  
  - Run theme.init
  - Register theme sections
  - Run common a11y fixes
  - Run RTE helpers to convert RTE tables to scrollable elements
  - Run RTE iframe helpers to make RTE iFrames responsive

==============================================================================*/





window.slate = window.slate || {};
window.theme = window.theme || {};





/*==============================================================================
  #SLATE a11y
==============================================================================*/

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

};










/*==============================================================================
  #SLATE Utility Helpers
==============================================================================*/

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 *
 * #EDIT
 * - Added arrayIncludes and uniq utilities for linked product options
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  arrayIncludes: function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
  }, 


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  uniq: function(e) {
      for (var t = [], n = 0; n < e.length; n++) slate.utils.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  }
};










/*==============================================================================
  #SLATE Rich Text Editor
==============================================================================*/

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};










/*==============================================================================
  #THEME Sections
==============================================================================*/

/**
 * Sections
 * - Largely based on Slate and Impulse theme with some minor adjustments.
 * - https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
 * - Added support for subsections
 * - Added simpler findInstance and removeInstance functions
 */


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  // Register event listeners for section events
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  // We are using subSections for dynamic non-homepage section blocks
  _onSectionLoad: function(evt, subSection, subSectionId) {

    // Check if we have a subSection or a Section
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    // If no subSection or Section exists, stop running
    if (!container) {
      return;
    }

    // Register section
    this._createInstance(container);

    // Store subSection or Section ID as an instance
    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // #? I don't understand this. Why is it loading subsections, if a
    // subsection doesn't exist?
    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  // Look for `data-subsection` attributes and load them
  _loadSubSections: function() {
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-id'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);

    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  // A simpler version of findInstance specific to sections
  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  // A simpler version of removeInstance specific to sections
  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    var $sections = $('[data-section-type=' + type + ']');

    $sections.each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});










/*==============================================================================
  #SLATE Currency
==============================================================================*/

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();










/*==============================================================================
  #SLATE Image
==============================================================================*/

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 * #EDIT: Added default size of 620x to imageSize function
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   *
   * Added default size of 620x
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();










/*==============================================================================
  #SLATE Variants
==============================================================================*/

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 *
 * #EDIT: 
 * - Added _updateSKU function
 * - Added _updateVariantButtons function for linked options
 * - Updated _getVariantFromOptions code to be simpler
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options

        selectedValues.forEach(function(option) {
          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariantButtons(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },


    /**
     * CUSTOM EVENT. If using buttons for our variants and linked options,
     * trigger change when selecting another button variant
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantButtonChange
     */
    _updateVariantButtons: function(variant) {
      this.$container.trigger({
        type: 'variantButtonChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();




















/*==============================================================================
  #CONFIG & UTILITIES
==============================================================================*/

/**
 * There is no accurate way of detecting a touch device using JS. Ideally, you
 * would wait for a users first iteraction and determine if it's a touch or
 * mouse move:
 * https://blogs.perficientdigital.com/2017/11/21/detecting-the-use-of-a-touch-screen/
 *
 * `ontouchstart` is used by Modernizer:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
 * 
 * `DocumentTouch`: very old and obsolete API since Gecko 25 (Firefox 25). Also
 * used by Modernizr.
 * https://developer.mozilla.org/en-US/docs/Web/API/DocumentTouch
 *
 * `maxTouchPoints`: returns number of touch contact points connected to the
 * device. Might not be best idea? Supported by Chrome Android, but not iOS.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
 *
 * `msMaxTouchPoints`: Only works for IE10. Future IEs removed this and used
 * standard `maxTouchPoints`:
 * https://technet.microsoft.com/en-us/windows/hh772144(v=vs.60)
 *
 * `matchMedia`: Similar to Prestige theme. matchMedia support is here:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 *
 * `moz-touch-events` no longer available to web content since Firefox 58:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/-moz-touch-enabled
 *
 * `isIpad` uses the JS test method to check if the userAgent matches the
 * string of `ipad`. Read negative things about userAgent detection but mainly
 * from long time ago. This iPad setting was used on Impulse theme to add a
 * 'js-ipad' class to body and change some background attachments to initial.
 * We won't need it.
 */


theme.config = {
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false || window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches,
  bpSmall: false
};





/**
 * Store our media queries here for easy use if we need breakpoints.
 */
theme.mq = {
  small: 'screen and (max-width: 767px)',
  medium: 'screen and (min-width: 768px) and (max-width: 1024px)',
  mediumUp: 'screen and (min-width: 768px)',
  large: 'screen and (min-width: 1025px) and (max-width: 1439px)',
  widescreen: 'screen and (min-width: 1440px)'
};




theme.setBreakpoints = function() {
  enquire.register(theme.mq.small, {
    match: function() {
      theme.config.bpSmall = true;
    },

    unmatch: function() {
      theme.config.bpSmall = false;
    }
  });

  enquire.register(theme.mq.mediumUp, {
    match: function() {
      theme.config.bpSmall = false;
    },

    unmatch: function() {
      theme.config.bpSmall = true;
    }
  });
}










/*==============================================================================
  #CartUtilities
  - Ajax Shopify API Utilities
==============================================================================*/

theme.CartUtilities = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.CartUtilities.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}










/*==============================================================================
  #AjaxProduct
==============================================================================*/

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {

    this.$form = $form;
    this.$addToCart = $('.js-add-to-cart');

    if (this.$form.length) {
      this.$addToCart.on('click', this.addItemFromForm.bind(this));

      // this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback){
      evt.preventDefault();

      var $target = $(evt.currentTarget);

      /**
       * A modal is opened for Age Check which includes a yes/no radio button form.
       * On click of the SUBMIT/add to cart button in the modal, we check the
       * radio button value. If the user has selected NO, we simply return and do
       * not add to cart. Otherwise, we add to cart as normal.
       */ 
      if ($target.hasClass('js-atc-age-check')) {

        var radioValue = $('input[name="age_check"]:checked').val();
        if (radioValue == 'no') {
          return;
        }
      }

      if (status.loading) {
        return;
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      status.loading = true;

      var data = this.$form.serialize();

      theme.CartUtilities.addItemFromForm(data)
        .then(function(product) {
          this.success(product);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.error(XMLHttpRequest);
        }.bind(this))
        .always(function() {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
    },

    success: function(product) {
      // this.$form.find('.alert--error').remove();
      $('.drawer__error').hide();

      if ($('.drawer__count').length) {
        $('.drawer__count').show();
      }

      if ($('.drawer__empty').length) {
        $('.drawer__empty').show();
      }

      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      // this.$form.find('.alert--error').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        $('.drawer__count').hide();
        $('.drawer__empty').hide();
        $('.drawer__error').text(XMLHttpRequest.responseJSON.description).show();
        theme.CartDrawer.open();

        // this.$addToCart.after('<div class="alert  alert--error  alert--spacing">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();


// YMAL product on mini cart
$(document).on('click', '.cart-product-recommendations .js-add-to-cart', function(evt) {
    // Prevent default action
    evt.preventDefault();

    // Fetch the variant ID from the clicked button
    var $button = $(this);
    var variantId = $button.data('variant-id');

    // Set the quantity to 1 (for YMAL products)
    var quantity = 1;

    // Prevent multiple submissions if the button is already loading
    if (status.loading) return;

    // Add loading state
    $button.addClass('btn--loading');
    status.loading = true;

    // Prepare data for the AJAX request
    var data = {
        id: variantId,
        quantity: quantity 
    };

    // Perform AJAX request to add item to the cart
    theme.CartUtilities.addItemFromForm(data)
      .then(function(product) {
          // Success callback: hide any errors and update the mini cart
          $('.drawer__error').hide();
          if ($('.drawer__count').length) {
              $('.drawer__count').show();
          }
          if ($('.drawer__empty').length) {
              $('.drawer__empty').show();
          }
          // Trigger a custom event to signal the product was added
          $('body').trigger('added.ajaxProduct');
      })
      .catch(function(XMLHttpRequest) {
          // Error callback: show an error if the request fails
          if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
              $('.drawer__count').hide();
              $('.drawer__empty').hide();
              $('.drawer__error').text(XMLHttpRequest.responseJSON.description).show();
              theme.CartDrawer.open();
          }
      })
      .always(function() {
          // Reset the loading state when the request completes
          status.loading = false;
          $button.removeClass('btn--loading');
      });
});
// YMAL product on mini cart



/*==============================================================================
  # Theme Load Image Section
  - Allows for adding classes whilst loading so we can animate
==============================================================================*/

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
};





















/*==============================================================================
  #MODULES
==============================================================================*/

/*==============================================================================
  #CustomSwitcher
  - A custom dropdown / page switcher element
==============================================================================*/

theme.CustomSwitcher = function() {
  // event handler for button
  $('.custom-switcher-button').on('click', toggleSwitcher);

  // toggle switcher
  function toggleSwitcher(evt) {
    var $this = $(this);
    var $parent = $this.parent();

    if ($parent.hasClass('custom-switcher-wrapper--is-active')) {
      closeSwitcher($parent);
    } else {
      openSwitcher($parent);
    }
  }

  function openSwitcher($parent) {
    $parent.addClass('custom-switcher-wrapper--is-active');
    $parent.find('.custom-switcher-button').attr({
      'aria-expanded': 'true'
    });

    $parent.find('.custom-switcher').attr({
      'aria-hidden': 'false'
    });

    $('body').on('click.customSwitcher', function(evt) {
      var $target = $(evt.target);
      if (!$target.hasClass('custom-switcher-button')) {
        closeSwitcher($parent);
      };
    });
  }


  function closeSwitcher($parent) {
    $parent.removeClass('custom-switcher-wrapper--is-active');
    $parent.find('.custom-switcher-button').attr({
      'aria-expanded': 'false'
    });

    $parent.find('.custom-switcher').attr({
      'aria-hidden': 'true'
    });

    $('body').off('click.customSwitcher');
  }
}










/*==============================================================================
  #HeaderNav
  - Dropdown functionality using click. Currently unused but worthwhile keeping
  in case you want to change in future.
==============================================================================*/

theme.HeaderNav = (function() {
  var selectors = {
    body: 'body',
    header: '.header',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',

    activeDropdown: '.header-nav__item--main--dropdown-is-open',
    dropdown: '.dropdown'
  };

  var cache = {};

  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown'
  }

  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $header: $(selectors.header),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.grandchildLinks),
      $dropdown: $(selectors.dropdown)
    };
  }


  function init() {
    // Make our cached objects available
    cacheSelectors();

    // Initialise ARIA attributes
    cache.$itemHasDropdown.find(selectors.mainLinks).attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });



    /**
     * 1. Dropdown click event handler 
     * The event handlers uses `evt.preventDefault()` to stop a link from 
     * firing, and allowing us to open or click a dropdown. This means that 
     * child links in our dropdown are also prevented from firing.
     */
    cache.$itemHasDropdown.on('click.' + config.namespace, toggleDropdown); /* [1] */

    /**
     * 2. Child and Grandchild Dropdown Links click event handler
     * Provides correct link behaviour to our child dropdown links. Our dropdown
     * click event handler prevents default link behaviour which also stops
     * our child dropdown links from firing. We use evt.stopPropagation on our 
     * child dropdown links to ensure they keep correct link behaviour.
     */
    cache.$childLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });

    cache.$grandchildLinks.on('click' + config.namespace, function(evt) { /* [2] */
      evt.stopPropagation();
    });
  };



  /**
   * toggleDropdown function is bound to our dropdown click event handler, so
   * we pass in evt to our function.
   */

  function toggleDropdown(evt) {

    // `this` will refer to the dropdown we have clicked on. We wrap `this` in a
    // jQuery object.
    var $this = $(this);


    /**
     * 1. Prevent default link behaviour. This allows the dropdown to open or close
     * rather than the link click being fired and being sent to another page.
     * 
     * 2. We have a click event handler on our body that closes dropdowns. 
     * We need to stop immediate propagation so the click event doesn't bubble 
     * up to body level and close the dropdown straight after it is revealed,
     * and no other event handlers on the element or parent are fired that
     * interfere.
     */
    evt.preventDefault(); /* [1] */
    evt.stopImmediatePropagation(); /* [2] */

    /**
     * If dropdown is open, we close the dropdown. Else we open it. We pass in
     * `$this` which is our dropdown into our open or close functions.
     */
    if ($this.hasClass(config.activeDropdown)) {
      closeDropdown($this);
    } else {
      openDropdown($this);
    }
  };



  /**
   * Open Dropdown function. We take a parameter which is the active dropdown
   */
  function openDropdown($this) {

    /**
     * If an active dropdown is open, close it before opening another dropdown.
     * We do not use a cached selector such as $activeDropdown because that 
     * does not get updated when the DOM changes.
     */
    if ($(selectors.activeDropdown).length) {
      closeDropdown($(selectors.activeDropdown));
    }

    $('.header').addClass('header--dropdown-is-open');

    // Show dropdown by adding class that will display dropdown
    $this.addClass(config.activeDropdown);
    $('.dropdown-overlay').addClass('dropdown-overlay--is-visible');

    $(".dropdown-nav__link").focus();

    // ARIA set expanded to true
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'true'
      }
    );

    if ($this.hasClass('header-nav__item--search')) {
      $('html').addClass('no-scroll');
      setTimeout("$('.header .ajax-search__input').focus();", 500);
    }

    /**
     * Attach event handlers to close the dropdown. These event handlers should
     * only fire when a dropdown is open.
     */

    // Close dropdown on click of body
    cache.$body.on('click' + config.namespace, function(evt) {
      closeDropdown($this);
    });

    // Ensure click in dropdown does not close dropdown
    cache.$dropdown.on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });

    // Close dropdown on keypress of escape
    cache.$window.on('keyup' + config.namespace, function(evt) { /* [2] */
      if (evt.which === 27) {
        closeDropdown($this);
      }
    });
  };



  /**
   * Close Dropdown function. We take a parameter which is the active dropdown
   */
  function closeDropdown($this) {

    $('.header').removeClass('header--dropdown-is-open');

    // Hide dropdown by removing class in CSS, so dropdown will display:none
    $this.removeClass(config.activeDropdown);
    $('.dropdown-overlay').removeClass('dropdown-overlay--is-visible');

    $('html').removeClass('no-scroll');

    // ARIA set expanded to false
    $this.find(selectors.mainLinks).attr(
      {
        'aria-expanded': 'false'
      }
    );

    /**
     * Detach event handlers to close dropdown. These event handlers were
     * attached when the dropdown is open, but not needed when closed.
     */
    cache.$body.off('click' + config.namespace);
    cache.$window.off('keyup' + config.namespace);

  };



  /**
   * Revealing module pattern, we expose a specific part of our module to the
   * global scope.
   */

  return {
    init: init,
    openDropdown: openDropdown
  };
})(); /* end theme.HeaderNav */











/*==============================================================================
  #HeaderNavTouch
  - Dropdown functionality using hover with additional code to handle
    touch devices.
  - From a UX and development perspective, the click dropdowns are better as
    we can't guarantee recognition of touch devices that don't intrinsically
    support hover.
==============================================================================*/

theme.HeaderNavTouch = (function() {

  var selectors = {
    body: 'body',
    header: '.header',
    itemHasDropdown: '.header-nav__item--main--has-dropdown',
    mainLinks: '.header-nav__link--main',
    childLinks: '.header-nav__link--child',
    grandchildLinks: '.header-nav__link--grandchild',

    activeDropdown: '.header-nav__item--main--dropdown-is-open',
    dropdown: '.dropdown'
  };

  var cache = {};

  var config = {
    activeDropdown: 'header-nav__item--main--dropdown-is-open',
    childLinks: 'header-nav__link--child',
    grandchildLinks: 'header-nav__link--grandchild',
    namespace: '.dropdown'
  }


  function cacheSelectors() {
    cache = {
      $window: $(window),
      $body: $(selectors.body),
      $header: $(selectors.header),
      $itemHasDropdown: $(selectors.itemHasDropdown),
      $mainLinks: $(selectors.mainLinks),
      $childLinks: $(selectors.childLinks),
      $grandchildLinks: $(selectors.childLinks),
      $dropdown: $(selectors.dropdown)
    };
  } /*----- END cacheSelectors() -----*/



  function init() {

    // Make our cached objects available
    cacheSelectors();

    // Initialise ARIA attributes on li elements with dropdown
    cache.$itemHasDropdown.attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });


    /**
     * TOUCH DEVICE EVENT HANDLER
     * There are difficulties with hover and mouseover states on touch devices.
     * Targeting touch devices is not 100% fool-proof.
     *
     * We need to make sure that the first tap on a touch device will open the
     * dropdown, and the second tap will take a user to their respective link.
     * Useful to be aware that as our `li` element has the event listeners, the
     * `a` link target event will bubble up to the `li` element.
     *
     * 1. If the dropdown is not open, we prevent default link behaviour and
     *    open the dropdown. 
     */
    if (theme.config.isTouch) {
      cache.$itemHasDropdown.on('click touchend' + config.namespace, function(evt) {
        var $el = $(this);

        if (!$el.hasClass(config.activeDropdown)) {
          evt.preventDefault(); /* [1] */
          openDropdown($el); /* [1] */
        }

      })
    };


    /**
     * EVENT HANDLER
     * We use this event handler for non-touch devices. If a user focuses or
     * hovers, we'll open the dropdown.
     * We use the `mouseenter` event as `mouseover` will track every movement
     * which we don't need.
     */

    cache.$itemHasDropdown.on('focusin mouseenter' + config.namespace, function(evt) {
      var $el = $(this);
      openDropdown($el);
    })

  }; /*----- END init() -----*/



  /**
   * Open Dropdown function. We take a parameter which is the list element the 
   * user has interacted with.
   */
  function openDropdown($el) {
    var keyTab = false;
    document.addEventListener("keydown", function(e){
       if(e.key === "Tab") {
        var hasClassFilters = e.target.classList.contains('header__logo-link');
        if(hasClassFilters == false) {
          keyTab = true;
        }
        else {
          closeDropdown($el);
        }
      }
    });

   

    $('.js-open-search').removeClass('search--is-open');

    /**
     * If an active dropdown is open, close it before opening another dropdown.
     * We do not use a cached selector such as $activeDropdown because that 
     * does not get updated when the DOM changes.
     */
    if ($(selectors.activeDropdown).length) {
      if(keyTab == false) closeDropdown($(selectors.activeDropdown));
    }


    $('.header').addClass('header--dropdown-is-open');

    // Show dropdown by adding class that will display dropdown
    $el.addClass(config.activeDropdown);
    $('.dropdown-overlay').addClass('dropdown-overlay--is-visible');


    // ARIA set expanded to true
    $el.attr(
      {
        'aria-expanded': 'true'
      }
    );


    if ($el.hasClass('header-nav__item--search')) {
      $('html').addClass('no-scroll');
      setTimeout("$('.header .ajax-search__input').focus();", 500);
    }


    /**
     * Attach event handlers to close the dropdown. These event handlers should
     * only fire when a dropdown is open.
     */
    $el.on('mouseleave' + config.namespace, function(evt){
      if(keyTab == false) closeDropdown($el);
    });


    /** 
     * 1. Attach focusout event on active dropdown to close when focus moves
     * to another element.
     *
     * 2. A focused element is referred to as `document.activeElement`. We want
     * to make sure that focusing on child dropdown links keeps the dropdown
     * open. The focusout event moves focus to the body for a fraction of a
     * second and then moves to the child element. So, we can use setTimeout to 
     * allow for getting focus on the child element, and stop our event firing
     * until we get there.
     */

    $el.on('focusout' + config.namespace, function(evt) { /* [1] */
      setTimeout(function() { /* [2] */
        if ($(document.activeElement).hasClass(config.childLinks) || $(document.activeElement).hasClass(config.grandchildLinks)) {
          return;
        }
       if(keyTab == false) closeDropdown($el);
      }, 0);
    });

  }; /*----- END openDropdown() -----*/



  /**
   * Close Dropdown function. We take a parameter which is the list element the 
   * user has interacted with.
   */

  function closeDropdown($el) {

    $('.header').removeClass('header--dropdown-is-open');

    // Hide dropdown by removing CSS class
    $el.removeClass(config.activeDropdown);
    $('.dropdown-overlay').removeClass('dropdown-overlay--is-visible');

    $('html').removeClass('no-scroll');

    // ARIA set expanded to false
    $el.attr(
      {
        'aria-expanded': 'false'
      }
    );

    $el.off('mouseleave' + config.namespace);
    $el.off('focusout' + config.namespace);
  };

  /**
   * Revealing module pattern, we expose a specific part of our module to the
   * global scope.
   */

  return {
    init: init,
    openDropdown: openDropdown
  };
})(); /* end theme.HeaderNavTouch */










/*==============================================================================
  #Modals
==============================================================================*/

theme.Modals = (function() {

  var selectors = {
    activeModal: '.modal--is-visible',
    openModal: '.js-open-modal',
    closeModal: '.js-close-modal',
    modalContent: '.modal__content'
  };

  var config = {
    activeModal: 'modal--is-visible',
    namespace: '.modal'
  }

  var $activeModal = $(selectors.activeModal);
  var modalIsOpen;
  var $html = $('html');

  if ($activeModal.length) {
    modalIsOpen = true;
  }

  function init() {
    $(selectors.openModal).on('click' + config.namespace, openModal);
    $(selectors.closeModal).on('click' + config.namespace, closeModal);
  }

  function openModal(evt) {

    // Make sure no other modal is already open. If so, close it.
    if (modalIsOpen) {
      closeModal();
    }

    evt.preventDefault();

    // Get Modal by ID tag. The aria-controls of the open button will match the ID of the modal.
    var $target = $(evt.currentTarget)
    var targetId = $target.attr('aria-controls');
    var $modal = $('#' + targetId);

    // Add active modal class
    $modal.addClass(config.activeModal);

    // Change aria-hidden
    $modal.attr('aria-hidden', 'false');

    // Add no scroll class to html
    $html.addClass('no-scroll');

    // If Back in Stock modal, set focus on email input
    if (targetId == 'BackInStockModal') {
      $('.back-in-stock-modal-btn').show();
      $('.js-bis-error').hide();
      $('.js-bis-success').hide();

      setTimeout(function () {
        $('#bisEmail').focus();
      }, 500);
    }

    if (targetId == 'SearchModal') {
      setTimeout("$('.modal--search .ajax-search__input').focus();", 500);
    }

    // Set $activeModal to the opened modal
    $activeModal = $modal;
    modalIsOpen = true;

    // Bind events
    bindEvents();
  }


  function closeModal(evt) {

    // Check that a modal is open. If not, return.
    if (!modalIsOpen) {
      return;
    }

    // Remove active class
    $activeModal.removeClass(config.activeModal);

    // Change aria-hidden
    $activeModal.attr('aria-hidden', 'true');

    // Remove no scroll class to html
    $html.removeClass('no-scroll');
    
    $('.back-in-stock__response').css('display', 'none');

    // Set $activeModal to false
    modalIsOpen = false;

    // Unbind Events
    unbindEvents();
  }


  function bindEvents() {

    // Close modal on ESC
    $(document).on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeModal();
      }
    })

    // Clicking outside of modal will close it
    $activeModal.on('click' + config.namespace, function(evt) {
      closeModal();
    });

    // However, we don't want it closed when clicking on modal content.
    $(selectors.modalContent).on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });
  }


  function unbindEvents() {

    // Remove escape keyup event
    $(document).off('keyup' + config.namespace);

    // Remove $activeModal click
    if ($activeModal) {
      $activeModal.off('click' + config.namespace);
    }

    // Remove modalContent click
    $(selectors.modalContent).off('click' + config.namespace);
  }

  return {
    init: init
  }

})();











/*==============================================================================
  #Drawers

   - Largely based off Shopify Timber Drawers, with inspiration from Pushy JS,
      and Drawer.js
    
    WHAT IT DOES:
    - This allows us to create multiple off-canvas drawers
    - We use a constructor function and create an instance for each drawer we
      would like
    - We use prototypes to add methods to our constructor that can be shared
      amongst all our drawer instances
    - Due to using prototypes, we must use `this.[property]` to expose variables
      to our prototype methods.

    HOW TO USE:
    - Create an instance of a drawer such as:

    var drawerVariableName = new Drawer(drawerId, drawerName)
==============================================================================*/

theme.Drawers = (function() {

  function Drawer(drawerId, drawerName) {

    this.id = drawerId;
    this.name = drawerName;

    this.selectors = {
      html: document.documentElement,
      body: 'body',
      MainContent: '#MainContent',
      // overlay: '.section--drawer',

      openBtn: '.js-drawer-open-' + drawerName,
      closeBtn: '.js-drawer-close'
    };

    this.cache = {
      $html: $(this.selectors.html),
      $body: $(this.selectors.body),
      $parent: $(this.selectors.html),
      $mainContent: $(this.selectors.mainContent),
      // $overlay: $(this.selectors.overlay),

      $openBtn: $(this.selectors.openBtn),
      $closeBtn: $(this.selectors.closeBtn)
    };

    // Config object
    this.config = {
      open: 'js-drawer-is-open',
      noScroll: 'no-scroll',

      activerDrawerParent: 'drawer-is-open',
      activeDrawer: 'drawer--is-open',

      namespace: '.drawer-' + name
    };

    // cache our drawer
    this.$drawer = $('#' + this.id);

    // Check if drawer exists
    if (!this.$drawer.length) {
      return false;
    }

    // Drawer flag to indicate if open or closed
    this.drawerIsOpen = false;

    // Last focus variable which will store the element that was focused prior
    // to opening the drawer
    this.$lastFocus = null;

    this.$overlay = this.$drawer.parent().find('.drawer-overlay');

    // Initialise our drawers
    this.init();
  };


  Drawer.prototype = $.extend({}, Drawer.prototype, {

    /* Drawer Init
     ======================================================================== */
    init: function() {
      var $openBtn = this.cache.$openBtn;

      // Attach aria-attributes on initialisation
      $openBtn.attr({
        'aria-controls': '#' + this.id,
        'aria-expanded': 'false'
      });

      /**
       * Open event handler. We use `.bind` to ensure that `this` refers to our 
       * Drawer object, not the jQuery object that is handling our event.
       */    
      $openBtn.on('click' + this.config.namespace, this.open.bind(this));
    },


    /* Drawer Open
     ======================================================================== */
    open: function(evt) {

      /**
       * When opening a drawer via a link we want to prevent the default 
       * behaviour of a link click event.
       *
       * When we open a drawer externally such as a Cart Drawer opening when 
       * an item is added to cart, `evt.preventDefault` encounters an error 
       * because there is no event, so evt is undefined.
       *
       * So, we use a conditional statement to check if our a drawer is opened
       * through an event/link click or externally.
       */
      if (evt) {
        evt.preventDefault();
      }

      // Defensive code to ensure that you can't open an already opened drawer
      if (this.drawerIsOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer. Doesn't cause issues for me.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();

        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }


      // Store our last focused element before opening the drawer as jQuery object
      this.$lastFocus = $(document.activeElement);

      // Show drawer
      this.$drawer.addClass(this.config.activeDrawer);

      // Add noScroll class to html/body
      this.cache.$parent.addClass(this.config.noScroll).addClass(this.config.activerDrawerParent);
      this.$overlay.addClass('drawer-overlay--is-visible');

      // Set active flag to true
      this.drawerIsOpen = true;

      // Trap focus to drawer
      // slate.a11y.trapFocus({
      //   $container: this.$drawer,
      //   namespace: 'drawer_focus'
      // });

      // Having this trigger, will allow us to close any modals/other elements
      // that may affect the drawer. An example is if we use a quickview modal
      // and add to cart, we want to close the modal, and open the cart drawer.
      $('body').trigger('drawerOpen.' + this.id);

      // Aria-expanded to true
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      // Bind close drawer event handlers
      this.bindEvents();
    },


    /* Drawer Close
     ======================================================================== */
    close: function() {

      // Defensive code to ensure you can't close a closed drawer
      if (!this.drawerIsOpen) {
        return;
      }

      /**
       * Add to Cart errors are printed in the drawer. We only want these to
       * show once. So we hide the errors on drawer close, and bring back
       * the default drawer count or empty drawer message.
       */
      if (this.id == 'CartDrawer') {
        $('.drawer__error').hide();

        if ($('.drawer__count').length) {
          $('.drawer__count').show();
        }

        if ($('.drawer__empty').length) {
          $('.drawer__empty').show();
        }
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      // Close drawer
      this.$drawer.removeClass(this.config.activeDrawer);

      this.$drawer.removeClass('drawer--drawer-panel-is-open');
      $('.drawer__panel').removeClass('drawer__panel--is-open');
      $('.js-close-drawer-panel').off('click.drawerPanel');

      // Remove noScroll
      this.cache.$parent.removeClass(this.config.noScroll).removeClass(this.config.activerDrawerParent);
      this.$overlay.removeClass('drawer-overlay--is-visible');

      // Set flag to false
      this.drawerIsOpen = false;

      // Remove focus
      // slate.a11y.removeTrapFocus({
      //   $container: this.$drawer,
      //   namespace: 'drawer_focus'
      // });

      // Aria-expanded to false
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      // Return focus to the element prior to opening our drawer    
      if (this.$lastFocus !== null) {
        this.$lastFocus.focus();     
      }

      // Unbind close drawer event handlers
      this.unbindEvents();
    },



    /* Drawer Bind Events
    ========================================================================= */
    bindEvents: function() {

      // Close on click of close button
      this.cache.$closeBtn.on('click' + this.config.namespace, this.close.bind(this));

      this.$overlay.on('click' + this.config.namespace, function (evt) {
          this.close();
      }.bind(this));

      // However, we don't want it closed when clicking on modal content.
      // this.$drawer.on('click' + this.config.namespace, function(evt) {
      //   evt.stopImmediatePropagation();
      // });

      // Close on keypress of escape key
      this.cache.$parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },


    /* Drawer Unbind Events
    ========================================================================= */
    unbindEvents: function() {
      this.cache.$parent.off(this.config.namespace);
      this.cache.$closeBtn.off(this.config.namespace);
      this.$overlay.off(this.config.namespace);
    }

  });

  return Drawer;
})();










/*==============================================================================
  #DrawerPanels
  
  - Controls behaviour of drawer panels in Drawer Menu for child/dropdown links
==============================================================================*/

theme.DrawerPanels = (function() {

  var selectors = {
    openPanel: '.js-open-drawer-panel',
    closePanel: '.js-close-drawer-panel',
    drawerMenu: '.drawer--menu',
    panel: '.drawer__panel'
  };

  var config = {
    namespace: '.drawerPanel',
    panelIsOpenParent: 'drawer--drawer-panel-is-open',
    panelIsOpen: 'drawer__panel--is-open'
  };


  var $openDrawer = $(selectors.openPanel);
  var $closeDrawer = $(selectors.closePanel);
  var $drawerMenu = $(selectors.drawerMenu);
  var $panel = $(selectors.panel);


  function init() {
    $openDrawer.on('click' + config.namespace, function(evt) {
      
      var $this = $(this);

      if (evt) {
        evt.preventDefault();
      }
      
      $drawerMenu.addClass(config.panelIsOpenParent);
      $this.parent().find('.drawer__panel').addClass(config.panelIsOpen);

      $closeDrawer.on('click' + config.namespace, function(evt) {
        evt.preventDefault();

        $drawerMenu.removeClass(config.panelIsOpenParent);
        $this.parent().find('.drawer__panel').removeClass(config.panelIsOpen);

        $closeDrawer.off('click' + config.namespace);
      });

    });
  };

  return {
    init: init
  };
})();












/*==============================================================================
  #Collapsibles
==============================================================================*/

/**
 * For smooth collapsibles we need to use height transitions. This is not 
 * supported in CSS, so we have to use JS.
 * https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-3
 */

theme.Collapsibles = (function() {

  var selectors = {
    scrollToCollapsible: '[data-scroll-to-collapsible]',
    keepMultipleOpen: '[data-keep-multiple-collapsibles-open]',
    collapsible: '.collapsible',
    button: '.collapsible__heading',
    panel: '.collapsible__panel',
    panelContent: '.collapsible__panel-content',
    activeCollapsible: '.collapsible--is-open'
  };

  var config = {
    activeCollapsible: 'collapsible--is-open',
    keepMultipleOpen: false,
    scrollToCollapsible: false
  }


  function init() {
    // Event handler on click
    $(selectors.button).on('click', function(evt) {

      // Get current event target which will be the collapsible button
      var $target = $(evt.currentTarget);

      // Get keepMultipleOpen selector if it exists
      var $keepMultipleOpen = $target.closest(selectors.keepMultipleOpen);

      var $scrollToCollapsible = $target.closest(selectors.scrollToCollapsible);

      /**
       * If we have a data-keep-multiple-collapsibles-open attribute on the
       * collapsible wrapper, we set the flag to true.
       */

      if ($keepMultipleOpen.length) {
        config.keepMultipleOpen = true;
      } else {
        config.keepMultipleOpen = false;
      }


      /**
       * Default collapsible functionality doesn't work well with long
       * content. Opening a new collapsible will often take users away
       * from the content. This variable controls whether to scroll to
       * a collapsible on click.
       */
      if ($scrollToCollapsible.length) {
        config.scrollToCollapsible = true;
      } else {
        config.scrollToCollapsible = false;
      }


      /**
       * If we have nested collapsibles, we ensure that click events don't bubble
       * so a nested collapsible doesn't open and then close.
       */
      evt.stopPropagation();

      // Pass our $target to toggleCollapsible function
      toggleCollapsible($target);
    });
  };



  // Pass in our $target element (the button that was clicked)
  function toggleCollapsible($target) {

    // Get the parent collapsible
    var $parentCollapsible = $target.closest(selectors.collapsible);

    // Get the collapsiblePanel
    var $collapsiblePanel = $parentCollapsible.find('> ' + selectors.panel);;


    /**
     * Check if the collapsible is open or closed and run the relevant function
     * passing in the parentCollapsible and collapsiblePanel
     */
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      closeCollapsible($parentCollapsible, $collapsiblePanel);
    } else {
      openCollapsible($parentCollapsible, $collapsiblePanel);
    }


    /**
     * If we want only one collapsible open at a time, we run this function
     * to close sibling collapsibles
     */
    if (!config.keepMultipleOpen) {

      $parentCollapsible.siblings(selectors.collapsible).each(function(index, element) {

        // This stores all parentCollapsibles
        var $parent = $(element);

        // This stores all collapsiblePanels
        var $panel = $parent.find('> ' + selectors.panel);

        closeCollapsible($parent, $panel);
      });
    }
  };


  // Pass in the parent collapsible, and collapsible panel
  function openCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already open, skip this function
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', true);


    // Get panel height
    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    // We need to declare an explicit height before setting to auto
    $collapsiblePanel.css({
      'overflow': 'visible',
      'height' : panelHeight + 'px'
    });

    // On completion of CSS transition, we set height to auto
    var transitionEnded = function transitionEnded(evt) {
      if (evt.originalEvent.propertyName === 'height') {
        $collapsiblePanel.css('height', 'auto');
        $collapsiblePanel.off('transitionend');

        /**
         * Scroll to collapsible. 
         */
        if (config.scrollToCollapsible) {
          var newPosition = $collapsiblePanel.offset();
          var scrollTarget = newPosition.top - 150;
          var timing = Math.abs( $(window).scrollTop() - scrollTarget ) * 2; //variable timings for different distances
          $('html, body').stop().animate({ scrollTop: scrollTarget }, timing);
        }
      }
    };

    $collapsiblePanel.on('transitionend', transitionEnded);

    // Add active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.addClass(config.activeCollapsible);

  }


  function closeCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already closed, skip this function
    if (!$parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', false);

    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    $collapsiblePanel.css({
      'overflow': 'hidden',
      'height' : panelHeight + 'px'
    });

    var offsetHeight = $collapsiblePanel.outerHeight();

    $collapsiblePanel.css({
      'height' : offsetHeight + 'px'
    });

    $collapsiblePanel.css({
      'height' : '0'
    });

    // Remove active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.removeClass(config.activeCollapsible);
  }


  return {
    init: init
  };
})();










/*==============================================================================
  #Tabs
==============================================================================*/

theme.Tabs = (function() {

  var config = {
    activeTab: 'tab--is-active'
  }

  function init() {
  }

  $('.tab').on('click', function(evt) {

    var $this = $(this);

    if ($this.hasClass(config.activeTab)) {
      return;
    }

    // Get Tab ID
    var tabId = $this.find('span').attr('id');

    /**
     * As we may have multiple tab components, we make heavy use of the parent()
     * selector. This ensures one tab component doesn't affect another.
     */
    // Remove active class and ARIA
    $this.parent().find('.tab').removeClass(config.activeTab);
    $this.parent().parent().find('.tab__panel').removeClass(config.activeTab).attr('aria-hidden', 'true');
    $this.parent().find('.tab > [aria-selected="true"]').attr('aria-selected', 'false');

    // Add active classes and ARIA
    $this.addClass(config.activeTab);
    $this.parent().parent().find('[aria-labelledby="tab-' + tabId + '"]').addClass(config.activeTab).attr('aria-hidden', 'false');
  });

  return {
    init: init
  }
})();











/*==============================================================================
  #Search
  - AJAX Search functionality
==============================================================================*/

theme.Search = (function() {

  var $searchForm = $('.ajax-search__form');
  var $searchInput = $('.ajax-search__input');
  var $searchResultsContainer = $('.ajax-search__results-container');

  var config = {
    namespace: 'search'
  };


  function init() {
    attachListeners();
  };


  function attachListeners() {
    $searchInput.on('input.' + config.namespace, $.debounce(250, runSearch));
  };


  function runSearch(evt) {

    var $this = $(this);
    var currentValue = $this.val();
    var currentAjaxRequest = null;

    // If empty value, clear results
    if (currentValue == '') {
      clearResults();
      return;
    }

    // Build AJAX url
    var url = '/search?view=ajax&q=' + encodeURI(currentValue) + '*' + '&type=product';

    // Defensive code to abort an AJAX request if we already have a request
    if (currentAjaxRequest != null) {
      currentAjaxRequest.abort();
    }

    // AJAX request
    currentAjaxRequest = $.ajax(url, {
      method: 'GET',
      dataType: 'html'
    })
    .done(function(data, textStatus, jqXHR) {
      // If we have data, we show results
      if (data.length) {
        $this.parent().parent().parent().find('.ajax-search__results-container').html(data);
      } else {
        // If there are no results, clear existing results
        clearResults();
      }
    })
    .fail(function() {
      console.log("AJAX search error");
    })
    .always(function() {

    });
  };

  function clearResults() {
    $('.ajax-search__results').empty();
  }

  return {
    init: init
  };

})();










/*==============================================================================
  #HeaderSearch
==============================================================================*/

theme.HeaderSearch = function() {

  $('.js-open-search').on('click.headerSearch', function(evt) {
    toggleSearch(evt);
  });

  function toggleSearch(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if ($('.js-open-search').hasClass('search--is-open')) {
      closeSearch();
    } else {
      openSearch();
    }
  }

  function openSearch() {
    $('.js-open-search').addClass('search--is-open');
    $('html').addClass('no-scroll');
    setTimeout("$('.header .ajax-search__input').focus();", 500);

    // Ensure click in dropdown does not close dropdown
    $('.dropdown--search').on('click.headerSearch', function(evt) {
      evt.stopImmediatePropagation();
    });
  }

  function closeSearch() {
    $('.js-open-search').removeClass('search--is-open');
    $('html').removeClass('no-scroll');
  }
}











/*==============================================================================
  #StickyProductForm
  - On scroll of PDP, the form fixes to the bottom of the screen and above
    the footer.
==============================================================================*/

theme.StickyProductForm = function() {
  var selectors = {
    form: '.product-form',
    formParent: '.product-form__container',
    footer: '.shopify-section--footer'
  };

  var config = {
    formFixed: 'product-form--is-fixed',
    formVisible: 'product-form--is-fixed-and-visible',
    namespace: 'StickyProductForm'
  };

  var cache = {
    $form: $(selectors.form),
    $formParent: $(selectors.formParent),
    $footer: $(selectors.footer)
  }

  /**
   * Get form height. We will add this as padding to the parent on scroll to
   * keep space and stop page jumps.
   */
  var formHeight = cache.$form.outerHeight(true);

  /**
   * isSticky flag used to control our logic
   */
  var isSticky = false;

  init();

  /**
   * 1. Attach event listeners
   */
  function init() {
    attachListeners(); /* [1] */
  };

  /**
   * 1. Scroll event listener throttled at 16 to mimic 60fps
   * 2. Resize event listener with debounce to improve performance
   */
  function attachListeners() {
    $(window).on('scroll.' + config.namespace, $.throttle(16, checkIfSticky)); /* [1] */
    $(window).on('resize.' + config.namespace, $.debounce(250, checkIfSticky)); /* [2] */
  };

  /**
   * 1. Get current scroll position
   * 2. Get distance from form to top of doc minus desktop header height
   * 3. Get distance between footer and top of doc
   * 4. Get footer height
   * 5. Check if scroll position is beyond Form and run sticky or unsticky
   */
  function checkIfSticky() {
    // var scrollPos = window.scrollY; /* [1] */
    var scrollPos = $(window).scrollTop();
    var formParentTop = cache.$formParent.offset().top - 90; /* [2] */
    var footerTop = cache.$footer.position().top; /* [3] */
    var footerHeight = cache.$footer.outerHeight(); /* [4] */

    if (scrollPos > formParentTop) { /* [5] */
      sticky();
      isSticky = true;
    } else {
      unsticky();
    }
  }


  /**
   * 1. If form is sticky, ensure to stickAboveFooter
   * 2. Set padding on form parent so keep space and stop page jumping
   * 3. Add a fixed class. This class has 0 opacity and a transform to place
   *    it under the viewport so we can have a smooth transition.
   * 4. On multiple scroll attempts, there can be a bug where position fixed
        is overwritten by the removeStickyStyles function. We add CSS here to 
        ensure position fixed overrides this.
   * 5. After a setTimeout we add a visible class to animate the form bar which
   *    will set opacity to 1, and transform to bottom of screen.
   */

  // function sticky() {
  //   if (isSticky) {
  //     stickAboveFooter(); /* [1] */
  //     return;
  //   }

  //   cache.$form.parent().css('padding-bottom', formHeight + 'px'); /* [2] */
  //   cache.$form.addClass(config.formFixed); /* [3] */

  //   $('.product-form--is-fixed').css({
  //     'position': 'fixed', /* [4] */
  //     'top': 'initial',
  //     'height': 'initial'
  //   });

  //   setTimeout(function () {
  //     cache.$form.addClass(config.formVisible); /* [5] */
  //   }, 10);
  // }


  /**
   * Unsticky function
   */
  function unsticky() {

    if (isSticky) {
      removeStickyStyles();
      
      cache.$form.parent().css('padding-bottom', '0px');
      cache.$form.removeClass(config.formVisible);
      cache.$form.removeClass(config.formFixed);

      isSticky = false;
    } else {
      return;
    }
  }


  /**
   * Remove sticky styles
   */
  function removeStickyStyles(){
    $('.product-form--is-fixed').css({
      'position': 'inherit',
      'top': 'inherit',
      'height': 'auto'
    });
  }
  

  /**
   * Stick above footer function
   */
  function stickAboveFooter() {
    var docHeight = $(document).height();
    var footerHeight = cache.$footer.outerHeight();
    var barHeight = $('.product-form--is-fixed').height() + 4; //+ account for 2px border top/bottom

    var footerBarTop = docHeight - footerHeight - barHeight;
  var footerSwitchTarget = docHeight - footerHeight;
    
    // var scrollPos = window.scrollY + window.innerHeight;
    var scrollPos = $(window).scrollTop() + window.innerHeight;
    //console.log(scrollPos);
    //console.log(JSON.stringify({docHeight:docHeight, footerHeight:footerHeight, barHeight:barHeight}));
    /**
     * We set position to absolute with a top position equal to the distance 
     * from footer to top of doc. 
     * Absolute positioning collapses the height of the Flexbox form, so we
     * need to set an explicit height.
     */
    if (scrollPos > footerSwitchTarget) {
      $('.product-form--is-fixed').css({
        'position': 'absolute',
        'top': footerBarTop + 'px',
        'height': barHeight + 'px'
      });
    } else {
      $('.product-form--is-fixed').css({
        'position': 'fixed',
        'top': 'inherit',
        'height': 'auto'
      });
    }
  }
};










/*==============================================================================
  #toggleHamper
  - Module to toggle the Hamper content on PDP pages
==============================================================================*/

theme.toggleHamper = function() {

  var $hamperProductsWrapper = $('.hamper-products__wrapper');
  var $hamperProducts = $('.hamper-products');
  var cssHeight = $('.hamper-products').css('height');
  var activeClass = 'hamper-products--is-open';

  $('.js-hamper-products-toggle').on('click', toggleHamper);
  initHamperHeight();
  
  
  function toggleHamper(evt) {
    if ($hamperProductsWrapper.hasClass(activeClass)) {
      closeHamper();
    } else {
      openHamper();
    }
  };


  function openHamper(evt) {
    var hamperHeight = $hamperProducts.prop('scrollHeight');

    $hamperProducts.css('height', hamperHeight + 'px');

    var transitionEnded = function transitionEnded(evt) {
      if (evt.originalEvent.propertyName === 'height') {
        $hamperProducts.css('height', 'auto');
        $hamperProducts.off('transitionend');
      }
    }

    $hamperProducts.on('transitionend', transitionEnded);
    $hamperProductsWrapper.addClass(activeClass);
  };


  function closeHamper(evt) {
    var self = this;

    var hamperHeight = $hamperProducts.prop('scrollHeight');

    $hamperProducts.css('height', hamperHeight + 'px');
    
    setTimeout(function() {
      setHamperHeight();
    }, 0);

    $hamperProductsWrapper.removeClass(activeClass);
  };
  

  function initHamperHeight(){
    setHamperHeight();
    $(window).on('resize', $.debounce(250, setHamperHeight));
  };
  

  function setHamperHeight(){
    var toggleHeader = $('.js-hamper-products-toggle');
    
    if (toggleHeader.is(":visible")){
      if(!$hamperProductsWrapper.hasClass(activeClass)){
        var firstGridItem = $('.hamper-products__content .grid__item').first();
        var gridItemHeight = firstGridItem.height();
        var gridItemPos = firstGridItem.position();
        var gridMargin = parseInt( firstGridItem.css("marginBottom").replace('px', ''));

        var hamperDivPos = $('.hamper-products').position();

        $hamperProducts.css('height', ((gridItemPos.top - hamperDivPos.top ) + gridItemHeight + gridMargin) + 'px');
      }
    } else{
      $hamperProducts.css('height', 'initial');
    }
  };

};




















/*==============================================================================
  #SECTIONS
==============================================================================*/

/*==============================================================================
  #HeaderSection
==============================================================================*/

theme.HeaderSection = (function() {

  function Header(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var selectors = this.selectors = {
      header: '.header',
      announcementBar: '.announcement-bar',
      announcementClose: '.js-announcement-bar-close'
    };

    var cache = this.cache = {
      $header: $(this.selectors.header),
      $announcementBar: $(this.selectors.announcementBar),
      $announcementClose: $(this.selectors.announcementClose)
    };

    var config = this.config = {
      headerHasScrolled: 'header--has-scrolled',
      headerHasNotScrolled: 'header--has-not-scrolled',
      announcementActiveClass: 'announcement-bar--is-active',
      announcementExpiry: this.options['announcementDays'],
      headerNamespace: '.header'
    };


    // Header scroll variables
    var prevScrollPos = 0;
    var hasScrolledUp = false;

    /**
     * If announcement bar enabled, we show it.
     */
    if (this.options['showAnnouncementBar']) {
      this.initAnnouncementBar();
    }

    theme.HeaderSearch();
    theme.HeaderNavTouch.init();
    this.initDrawers();

    /**
     * We use position sticky for the header. This extension is a fallback
     * for older, non-suppported browsers.
     */
    stickybits('.shopify-section--header');

    /**
     * Scroll event listener for header.
     * Use a throttle of 16 that matches 60fps.
     */
    $(window).on('scroll' + config.headerNamespace, $.throttle(16, onScroll).bind(this));


    /**
     * Scroll event handler. On scroll down, we hide the header. On scroll up,
     * we show the header.
     */
    function onScroll() {
      var scrollPos = window.scrollY;
      var scrollThreshold = 0;

      if (scrollPos > scrollThreshold) {
        cache.$header.removeClass(config.headerHasNotScrolled);
        cache.$header.addClass(config.headerHasScrolled);
      } else {
        cache.$header.removeClass(config.headerHasScrolled);
        cache.$header.addClass(config.headerHasNotScrolled);
      }

      prevScrollPos = scrollPos;
    }


    /**
     * Dropdown images function
     * On hover of dropdown links, show collection image and link.
     */
    $('[data-dropdown-index]').on('mouseover', function(evt) {
      var $this = $(this);
      var index = $this.attr('data-dropdown-index');

      if ($('[data-dropdown-image="' + index + '"]').hasClass('dropdown__image-link--is-active')) {
        return;
      }

      $('.dropdown__image-link').css('display', 'none').removeClass('dropdown__image-link--is-active');

      $('[data-dropdown-image="' + index + '"]').css('display', 'block');

      setTimeout(function() { /* [2] */
        $('[data-dropdown-image="' + index + '"]').addClass('dropdown__image-link--is-active');
      }, 150);

    });
  }

  Header.prototype = $.extend({}, Header.prototype, {

    initDrawers: function() {
      theme.MenuDrawer = new theme.Drawers('MenuDrawer', 'menu');

      if (theme.settings.cartType === 'drawer') {
        theme.CartDrawer = new theme.Drawers('CartDrawer', 'cart');
      }
    },

    initAnnouncementBar: function() {

      /**
       * 1. The announcement bar is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the bar. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */

      if (this.options['announcementDisplayMode'] == 'enabled') {
        if (Cookies.get('announcementBar') == 'closed') {
          return; /* [1] */
        } else {
          this.showAnnouncementBar();
        }
      } else if (this.options['announcementDisplayMode'] == 'testing') {
        this.resetAnnouncementBar(); /* [2] */
      }


      /**
       * Event handler to close the announcement bar on click.
       * Hides the announcement bar and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$announcementClose.on('click', function(evt) {
        this.hideAnnouncementBar();

        Cookies.set('announcementBar', 'closed', { expires: this.config.announcementExpiry });
      }.bind(this));
    },


    showAnnouncementBar: function() {
      this.cache.$announcementBar.addClass(this.config.announcementActiveClass);

      // Reevaluate header height when announcement is open
      document.documentElement.style.setProperty('--header-height', document.getElementById('Section--header').offsetHeight + 'px');
    },


    hideAnnouncementBar: function() {
      this.cache.$announcementBar.removeClass(this.config.announcementActiveClass);

      // Reevaluate header height when announcement is closed
      document.documentElement.style.setProperty('--header-height', document.getElementById('Section--header').offsetHeight + 'px');
    },


    resetAnnouncementBar: function() {
      Cookies.remove('announcementBar');
      this.showAnnouncementBar();
    },

    /**
     * Shopify Theme Editor events
     */

    onSelect: function() {
      theme.HeaderNavTouch.init();
      this.resetAnnouncementBar();
    }

  });

  return Header;

})();











/*==============================================================================
  #PopupSection - Old version
==============================================================================*/

theme.PopupSectionDays = (function() {

  function PopupSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Store our selectors
    this.selectors = {
      popup: '.popup',
      popupActive: '.popup--is-visible',
      popupContent: '.popup__content',
      popupClose: '.js-popup-close'
    };

    // Cache selectors
    this.cache = {
      $popup: $(this.selectors.popup),
      $popupClose: $(this.selectors.popupClose)
    };

    // Config and active classes
    this.config = {
      popupActiveClass: 'popup--is-visible',
      popupExpiry: this.options['popupDays'],
      namespace: 'popup'
    };

    if (this.options['showPopup']) {
      this.initPopup();
    }

  }

  PopupSection.prototype = $.extend({}, PopupSection.prototype, {

    initPopup: function() {

      /**
       * 1. The popup is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the popup. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */

      if (this.options['popupDisplayMode'] == 'enabled') {
        if (Cookies.get('popup') == 'closed') {
          return; /* [1] */
        } else {
          setTimeout(function() {
            this.showPopup();
          }.bind(this), this.options['popupDelay'] * 1000);
        }
      } else if (this.options['popupDisplayMode'] == 'testing') {
        this.resetPopup(); /* [2] */
      }


      /**
       * Event handler to close the popup on click.
       * Hides the popup and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$popupClose.on('click', function(evt) {
        this.hidePopup();
      }.bind(this));



      /**
       * Event handler to close the popup when clicking outside.
       * Hides the popup and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$popup.on('click.popup', function(evt) {
        this.hidePopup();
      }.bind(this));


      /**
       * Make sure the popup doesn't close when clicking on the popup itself.
       */

      $(this.selectors.popupContent).on('click.popup', function(evt) {
        evt.stopImmediatePropagation();
      }.bind(this));

    },


    showPopup: function() {
      this.cache.$popup.addClass(this.config.popupActiveClass);
      $('body').addClass('no-scroll');
    },


    hidePopup: function() {
      this.cache.$popup.removeClass(this.config.popupActiveClass);
      $('body').removeClass('no-scroll');
      Cookies.set('popup', 'closed', { expires: this.config.popupExpiry });

      this.cache.$popup.off('click.popup');

      $(this.selectors.popupContent).off('click.popup');
    },


    resetPopup: function() {
      Cookies.remove('popup');
      this.showPopup();
    },


    onSelect: function() {
      this.resetPopup();
    }

  });

  return PopupSection;

})();










/*==============================================================================
  #PopupSection - Correct version based on amount of pages visited by user
==============================================================================*/

theme.PopupSection = (function() {

  
  function PopupSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    //avoid these pages
    this.triggerClose = ['newsletter-thank-you'];
    this.dontShow = ['cart','contact','thank','account','newsletter-signup'];
    
    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Store our selectors
    this.selectors = {
      popup: '.popup',
      popupActive: '.popup--is-visible',
      popupContent: '.popup__content',
      popupClose: '.js-popup-close'
    };

    // Cache selectors
    this.cache = {
      $popup: $(this.selectors.popup),
      $popupClose: $(this.selectors.popupClose)
    };

    // Config and active classes
    this.config = {
      popupActiveClass: 'popup--is-visible',
      popupExpiry: this.options['popupDays'],
      popupPages: this.options['popupPages'],
      namespace: 'popup'
    };

    if (this.options['showPopup']) {
      this.initPopup();
    }

  }

  PopupSection.prototype = $.extend({}, PopupSection.prototype, {

    initPopup: function() {

      /**
       * 1. The popup is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the popup. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */
    
      console.log('popup init');
      
      if( this.checkURL(this.triggerClose) ){
          Cookies.set('popup', 'closed', { expires: this.config.popupExpiry });
          console.log('popup close triggered');
          return;
      }
      
      if(this.checkURL(this.dontShow)){
          console.log('popup not shown');
          return;
      }
      
      if (this.options['popupDisplayMode'] == 'enabled') {
        if (Cookies.get('popup') == 'closed') {
          return; /* [1] */
        } else {
          if (typeof Cookies.get('visited') === "undefined") {
            Cookies.set("visited", 0);
          }

          if (parseInt(Cookies.get('visited')) >= this.options['popupPages'] - 1) {
            setTimeout(function() {
              this.showPopup();
            }.bind(this), this.options['popupDelay'] * 1000);
          } else {
            var increase = parseInt(Cookies.get('visited')) + 1;
            Cookies.set('visited', increase, { expires: this.config.popupExpiry });
            return false;
          }
        }
      } else if (this.options['popupDisplayMode'] == 'testing') {
        this.resetPopup(); /* [2] */
      }


      /**
       * Event handler to close the popup on click.
       * Hides the popup and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$popupClose.on('click', function(evt) {
        this.hidePopup();
      }.bind(this));



      /**
       * Event handler to close the popup when clicking outside.
       * Hides the popup and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$popup.on('click.popup', function(evt) {
        this.hidePopup();
      }.bind(this));


      /**
       * Make sure the popup doesn't close when clicking on the popup itself.
       */

      $(this.selectors.popupContent).on('click.popup', function(evt) {
        evt.stopImmediatePropagation();
      }.bind(this));

    },


    checkURL: function(urls) {
      var path = window.location.pathname;
      var found = false;
      $(urls).each(function(i,keyword){
        if( path.indexOf(keyword) !== -1 ){ found = true; }
      });
      return found;
    },
    
    showPopup: function() {
      this.cache.$popup.addClass(this.config.popupActiveClass);
                  setTimeout(function() {
              $(".popup-newsletter__input").focus();
            }, 1000);
      
      $('body').addClass('no-scroll');
    },


    hidePopup: function() {
      this.cache.$popup.removeClass(this.config.popupActiveClass);
      $('body').removeClass('no-scroll');
      Cookies.set('popup', 'closed', { expires: this.config.popupExpiry });

      this.cache.$popup.off('click.popup');

      $(this.selectors.popupContent).off('click.popup');
    },


    resetPopup: function() {
      Cookies.remove('popup');
      Cookies.set("visited", this.options['popupPages']);
      this.showPopup();
    },


    onSelect: function() {
      this.resetPopup();
    }

  });

  return PopupSection;

})();










/*==============================================================================
  #CookiesSection
==============================================================================*/

theme.CookiesSection = (function() {

  function CookiesSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Store our selectors
    this.selectors = {
      cookiesBar: '.cookies-bar',
      cookiesBarClose: '.js-cookies-bar-close'
    };

    // Cache selectors
    this.cache = {
      $cookiesBar: $(this.selectors.cookiesBar),
      $cookiesBarClose: $(this.selectors.cookiesBarClose)
    };

    // Config and active classes
    this.config = {
      cookiesBarActiveClass: 'cookies-bar--is-active'
    };

    if (this.options['showCookiesBar']) {
      this.initCookiesBar();
    }

  }

  CookiesSection.prototype = $.extend({}, CookiesSection.prototype, {

    initCookiesBar: function() {

      /**
       * 1. The cookies bar is hidden by default in our stylesheet. We use
       *    cookies to check if a user has closed the bar. If they have, we 
       *    don't run the code.
       * 
       * 2. We have a displayMode called 'Testing'. This allows the merchant to
       *    override the cookie settings in the Theme Editor so they can make
       *    edits.
       */

      if (this.options['cookiesDisplayMode'] == 'enabled') {
        if (Cookies.get('cookies') == 'accepted') {
          return; /* [1] */
        } else {
          this.showCookiesBar();
        }
      } else if (this.options['cookiesDisplayMode'] == 'testing') {
        this.resetCookiesBar(); /* [2] */
      }


      /**
       * Event handler to close the announcement bar on click.
       * Hides the announcement bar and sets a cookie with an expiry set by
       * the merchant in the Theme Editor.
       */

      this.cache.$cookiesBarClose.on('click', function(evt) {
        this.hideCookiesBar();
        Cookies.set('cookies', 'accepted', { expires: 365 });
      }.bind(this));
    },


    showCookiesBar: function() {
      this.cache.$cookiesBar.addClass(this.config.cookiesBarActiveClass);
    },


    hideCookiesBar: function() {
      this.cache.$cookiesBar.removeClass(this.config.cookiesBarActiveClass);
    },


    resetCookiesBar: function() {
      Cookies.remove('cookies');
      this.showCookiesBar();
    },


    onSelect: function() {
      this.resetCookiesBar();
    }

  });

  return CookiesSection;

})();











/*==============================================================================
  #Cart
  - This code handles major cart related functionality on both the cart page and
    the AJAX cart drawer.
==============================================================================*/

theme.Cart = (function() {

  var itemCount = window.theme.settings.cartCount;
  var loading = false;


  function init() {
    /**
     * On custom event `added.ajaxProduct` we run buildCart. This is triggered 
     * in `theme.ProductForm`. We don't place this in our initEventListeners()
     * function as we don't need to re-run this, as it's triggered elsewhere.
     *
     * The function will run the AJAX request to get our cart. We need to pass
     * this cart object in to our buildCart function.
     */
    $('body').on('added.ajaxProduct', function() {
      theme.CartUtilities.getCart().then(function(cart) {
        buildCart(cart);
      }.bind(this));
    }.bind(this));

    // Store cart note when AJAX cart changes
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.CartUtilities.updateNote(newNote);
    });
    
    initEventListeners();
  };


  function initEventListeners() {

    /**
     * Quantity related event listeners
     */
    $('.js-qty-increase').on('click', updateQuantity);
    $('.js-qty-decrease').on('click', updateQuantity);
    $('.js-qty-input').on('blur', updateQuantity);
  };


  function updateQuantity(evt) {

    // Prevent default link behaviour for remove link
    evt.preventDefault();

    // Store our target element
    var $target = $(evt.currentTarget);

    // Set quantity
    var parsedQuantity = 1;

    // Get variant ID
    var id = $target.attr('data-line-id');
    var currentValue = 1;
  
    // If target is our input element
    if ($target.hasClass('js-qty-input')) {

      // Get the current value
      currentValue = parseInt($target.attr('data-current-value'));

      // Get the new user-input value
      parsedQuantity = parseInt($target.val());

      // Check that new user-input value is a number. If not, default to the current value.
      if (!Number.isInteger(parsedQuantity)) {
        parsedQuantity = currentValue;
      }

      // Set the input element to our new user-input value or current value
      $target.val(parsedQuantity);

      // Return if current value is same as new value
      if (currentValue === parsedQuantity) {
        return;
      }
    } else {

      // Get new quantity if using the +/- increment buttons
      parsedQuantity = parseInt($target.attr('data-quantity'));

      //infer the previous value 
      if ($target.hasClass('js-qty-increase')) {
        currentValue = parsedQuantity-1;
        console.log(currentValue);
      }else{
        currentValue = parsedQuantity+1;
        console.log(currentValue);
      }
      // Set our input as the new quantity
      $target.siblings('.js-qty-input').val(parsedQuantity);
    }

    if( (parsedQuantity == 0)||(currentValue > parsedQuantity) ){
      var line_item_qty = currentValue - parsedQuantity;
      if(typeof ga4_tracker != 'undefined'){ ga4_tracker.remove_from_cart(id,line_item_qty); }
    }else{
      var line_item_qty = parsedQuantity - currentValue;
      if(typeof ga4_tracker != 'undefined'){ ga4_tracker.add_from_cart(id,line_item_qty); }
    }
    
    // Run updateItem with our event, variant ID, and new quantity
    updateItem(evt, id, parsedQuantity);
  };


  function updateItem(evt, id, qty) {
    if (loading) {
      return;
    }

    loading = true;

    theme.CartUtilities.changeItem(id, qty)
      .then(function(cart) {
        updateSuccess(cart);
      }.bind(this))
      .catch(function(XMLHttpRequest) {
        updateError(XMLHttpRequest);
      }.bind(this))
      .always(function() {
        loading = false;
      }.bind(this));
  };


  function buildCart(cart) {

    loading = true;

    var cart = cart;
    var url = '';

    /**
     * Depending on whether we're on the cart template or outside of it, we pull
     * in a specific cart template. We're not using a templating library such as
     * Handlebars. This is a potentially more app-friendly solution as we can
     * re-run liquid. This solution is influenced by Maestrooo on their Prestige
     * and Warehouse themes.
     */
    if (window.theme.settings.template !== 'cart') {
      url = '/cart?view=drawer&timestamp=' + Date.now();
    } else {
      url = '/cart?timestamp=' + Date.now();
    }

    $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {

        if (window.theme.settings.template !== 'cart' && window.theme.settings.cartType === 'drawer') {
          
          // Update Cart Drawer Items
          var tempElement = document.createElement('div');
          tempElement.innerHTML = data;

          var headerNodeParent = document.querySelector('.drawer__header--cart').parentNode
          var cartNodeParent = document.querySelector('.js-cart-content').parentNode;
          // var summaryNodeParent = document.querySelector('.drawer__summary').parentNode;

          cartNodeParent.replaceChild(tempElement.querySelector('.js-cart-content'), document.querySelector('.js-cart-content'));

          // summaryNodeParent.replaceChild(tempElement.querySelector('.drawer__summary'), document.querySelector('.drawer__summary'));

          headerNodeParent.replaceChild(tempElement.querySelector('.drawer__header--cart'), document.querySelector('.drawer__header--cart'));

          theme.CartDrawer.open();

        } else {
          // We are forcing a location reload on the cart page to ensure we run
          // any necessary JS for 3rd party apps etc.
          window.location.reload();
        }

      })
      .fail(function() {
        console.log("error");
      })
      .always(function() {
        loading = false;
        initEventListeners();

        /**
         * Ensure continue shopping button reinits close event
         */
        $('.js-drawer-close').on('click.drawer-cart', function(evt) {
          theme.CartDrawer.close();
        });
      });

      $('.header__cart-count').text(cart.item_count);
  };


  function updateSuccess(cart) {
    buildCart(cart);
  };


  function updateError(XMLHttpRequest) {
    if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
      console.warn(XMLHttpRequest.responseJSON.description);
    }
  };

  return {
    init: init
  };

})();











/*==============================================================================
  #Product
==============================================================================*/

theme.Product = (function() {

  var selectors = {};

  var config = {};

  function Product(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {
      enableHistoryState: this.options['enableHistoryState'],
      groupImagesByAlt: this.options['groupImagesByAlt'],
      preorder: this.options['preorder'],
      ageCheck: this.options['ageCheck'],
      imageZoomLevel: this.options['imageZoomLevel'],
      productUnavailable: this.options['productUnavailable'],
      namespace: '.product-' + sectionId
    };


    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      productSlider: '.js-product-slider-' + sectionId,

      price: '.js-product-price-' + sectionId,
      comparePrice: '.js-product-compare-price-' + sectionId,

      addToCart: '.js-add-to-cart-' + sectionId,
      addToCartText: '.js-add-to-cart-text-' + sectionId,

      originalSelectorId: '.js-product-form-selector-master-' + sectionId,
      singleOptionSelectorRadio: '.variant-button__input',
      singleOptionSelector: '.js-product-form-selector-' + sectionId,

      formContainer: '.js-product-form-' + sectionId
    };

    // Check this is a product object
    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    // Parse our product json object
    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);


    // Cache slider and image variables
    this.$productSlider = $(this.selectors.productSlider);

    // We get our first product image
    this.$firstProductImage = this.$productSlider.find('img').first();


    // Share functionality
    var shareIsOpen = this.shareIsOpen = false;

    // Attach share listener
    $('.js-product-share-btn').on('click', this.toggleShare.bind(this));

    // Initialise section
    this.init();
  }


  Product.prototype = $.extend({}, Product.prototype, {

    init: function() {

      if (!this.settings.productUnavailable) {
        this.productFormSetup();
        theme.StickyProductForm();
        this.initBackInStock();
      }

      this.initBreakpoints();
      this.createImageSlider();
      this.photoswipe();
      theme.toggleHamper();
      this.initAccordion();
      // this.initBreakpoints();
     
    },


    /**
     * This function is currently not needed. the `config.isTouch` variable
     * determines whether to intialise the image zoom
     */
    initBreakpoints: function() {
      var self = this;

      enquire.register(theme.mq.mediumUp, {
        match: function() {
          // var $image = $('.product__slide--is-visible.is-selected');
          // self.initZoom($image);
          // self.destroyImageSlider();
          self.createImageSlider();
        }
      });

      enquire.register(theme.mq.small, {
        match: function() {
          // self.destroyZoom();
          // self.destroyImageSlider();
          self.createImageSlider();
        }
      });
    },
    
     photoswipe: function() {
          var pswpElement = document.querySelectorAll('.pswp')[0];
          var items = this.getImagedata();
          var options = {
            index: 0,
            closeOnScroll: false,
            tapToToggleControls: false
          };
          //var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          //gallery.init();

          var x = document.querySelectorAll(".opengallery");
          for (let i = 0; i < x.length; i++) {
            x[i].addEventListener("click", function() {
              opengallery(x[i].getAttribute('data-image'));
            });
          }

          function opengallery(j) {
            options.index = parseInt(j);
            gallery1 = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery1.init();
          }


        },

        getImagedata: function() {
         this.$images = $(".photoswipe__image");
        var haveImages = false;
        var items = [];
        var options = {};

        $(".photoswipe__image").each(function() {
          var haveImages = true;
          var item = {
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            msrc:$(this).data('photoswipe-msrc'),
          };

          items.push(item);
        });

        return items; 
        },

        Photoswipe: function() {
          this.gallery;
         var $trigger = $(this.selectors.trigger);     
        // Init gallery on active image
        $trigger.on('click', function(evt) {
          items = this.getImageData();
          var index = $(this.selectors.activeImage).data('index');
        /*  if (this.inSlideshow || theme.config.bpSmall) {
            var index = $(this.selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          */
          this.initGallery(items, index);
        }.bind(this));
       },

       getImageData: function() {
        this.$images = $(this.selectors.images);
        var haveImages = false;
        var items = [];
        var options = {};

        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
         console.log($(this).data('photoswipe-src'));
          console.log("IAMMMMM");
          console.log(smallSrc);
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };

          items.push(item);
        });

        return items;
      },


    productFormSetup: function() {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },


    toggleShare: function() {
      var self = this;

      if (self.shareIsOpen) {
        $('.product__share').removeClass('product__share--is-open');
        self.shareIsOpen = false;
      } else {
        $('.product__share').addClass('product__share--is-open');
        self.shareIsOpen = true;
      }
    },


    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelectorRadio,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productObject
      }

      this.variants = new slate.Variants(options);

      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));

      if (this.settings.groupImagesByAlt) {
        this.$container.on('variantChange' + this.settings.namespace, this.updateVariantSlides.bind(this));
      }

    },


    updatePrice: function(evt) {

      var variant = evt.variant;

      if (variant) {

        // Update current price
        $(this.selectors.price).html(slate.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

        if (variant.compare_at_price > variant.price) {

          // If on sale, update compare at price (aka regular price)
          $(this.selectors.comparePrice).html(slate.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
        }
      }
    },


    updateCartButton: function(evt) {

      var variant = evt.variant;
      var $dynamicPaymentButton;

      if (this.settings.showPaymentButton) {
        $dynamicPaymentButton = $('.shopify-payment-button');
      }

      if (variant) {

        if (variant.available) {

          /**
           * If variant is available,
           * - hide back in stock button
           * - show add to cart button, remove disabled attribute, and update
           *   text
           */
          $('.back-in-stock-message').hide();
          $('.back-in-stock-btn').hide();
          $(this.selectors.addToCart).show();
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);

          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.show();
          }

        } else {

          /**
           * If variant is NOT available,
           * - show back in stock button
           * - hide add to cart button, add disabled attribute, and update
           *   text
           */
          $(this.selectors.addToCart).hide();
          $('.back-in-stock-message').show();
          $('.back-in-stock-btn').show();
          $('.back-in-stock-variant').html(variant.title);
          // Add disabled attribute and show Sold Out text
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);

          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.hide();
          }
        }

      } else {

        /**
         * If variant does not exist
         * - hide back in stock button
         * - show add to cart button, add disabled attribute, and update
         *   text
         */
        $('.back-in-stock-btn').hide();
        $('.back-in-stock-message').hide();
        $(this.selectors.addToCart).show();
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);

        if (this.settings.showPaymentButton) {
          $dynamicPaymentButton.hide();
        }
      }
    },


    updateVariantImage: function(evt) {
      
      // variantImageChange evt stores our variant object
      var variant = evt.variant;

      // Retrieve index of our new image
      var $newImage = $('.product__slide[data-image-id="' + variant.featured_image.id + '"]');
      var imageIndex = this._slideIndex($newImage);

      // If there is no index, slider is not initalized
      if (typeof imageIndex === 'undefined') {
        return;
      }

      // Go to slide
      this.$productSlider.flickity( 'selectCell', imageIndex);
    },


    // Unused function for quantity selector
    initQtySelector: function() {
      $(this.selectors.qtyDecrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      });

      $(this.selectors.qtyIncrease).on('click', function(evt) {
        var target = evt.currentTarget;
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      });
    },


    initAjaxProductForm: function() {
      // If we are using a AJAX drawer, pass our form to AjaxProduct function
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },


    /**
     * A custom integration for the Back in Stock app. When a user selects an
     * out of stock variant, we show a custom button that is controlled in
     * `updateCartButton` function. The button opens a modal which includes
     * the back in stock form. This function handles the form submission.
     */
    initBackInStock: function() {

      // Register the master selector. We use this to grab the variant ID.
      var $originalSelectorId = $(this.selectors.originalSelectorId);

      var $bisForm = $('.back-in-stock__form');

      var notificationCallback = function(data) {
        
        var msg = '';

        if (data.status == 'OK') {
          msg = data.message;
          
          $('.js-bis-error').hide();
          $('.js-bis-success').text(msg).show();
          $('.back-in-stock-modal-btn').hide();
        } else {

          // Loop through errors and join in a string.
          for (var errorItem in data.errors) {
            msg += data.errors[errorItem].join();
          }

          $('.js-bis-success').hide();
          $('.js-bis-error').text(msg).show();
        }
      }

      // Form handler
      $bisForm.on('submit', function(evt) {
        evt.preventDefault();

        var email = $('#bisEmail').val();
        var productId = $('.product').attr('data-product-id');
        var variantId = $originalSelectorId.children('option:selected').val();

        // Creates the notification
        BIS.create(email, variantId, productId).then(notificationCallback); 
      });
    },


    createImageSlider: function() {

      // Store variables
      var self = this;
      var initialSlideIndex = 0;
      var productSlides;
      var slideCount = 0;

      // If the slideshow exists, set some variables
      if (this.$productSlider) {
        productSlides = $('.product__slide');
        slideCount = parseInt(this.$productSlider.attr('data-image-count'));
      } else {
        productSlides = [];
      };


      // If zoom is enabled and not using a touch device, we initialise zoom
      // on our first image only.  
      if (!theme.config.isTouch) {
        var $image = $('.product__slide--is-visible').first();
        this.initZoom($image);
      };


      /**
       * If we have more than one slide, we initialise the slideshow
       */
      if (slideCount > 1) {

        /**
         * If the product groups variant images by ALT tag, we need to run some
         * code to determine what slides to show.
         */

        if (this.settings.groupImagesByAlt) {
          /**
           * A new array is created that will contain visible slides
           */
          var visibleSlides = [].slice.call(productSlides).filter(function(slide){
            return slide.classList.contains('product__slide--is-visible');
          });


          /**
           * The slider stores the selected/current variant image ID. If a slide
           * matches this, we set the index for our initial slide
           */
          visibleSlides.forEach(function(slide, index) {
            if (slide.getAttribute('data-image-id') === self.$productSlider.attr('data-initial-image-id')) {
              initialSlideIndex = index;
            }
          });
        }

        // Crappy way to prevent duplicate event listeners
        this.$productSlider.off('change.flickity');
        this.$productSlider.on('change.flickity', this.onSlideChange.bind(this));
    let adaptHeight = false;

        if (theme.config.bpSmall) {
          this.$productSlider.flickity({
            prevNextButtons: false,
            pageDots: true,
            adaptiveHeight: adaptHeight,
            selectedAttraction: 0.025,
            friction: 0.28,
            contain: true,
            cellAlign: 'left',
            cellSelector: '.product__slide--is-visible',
            initialIndex: initialSlideIndex,
            draggable: true
          });
        } else {
          this.$productSlider.flickity({
            prevNextButtons: true,
            pageDots: true,
            adaptiveHeight: adaptHeight,
            selectedAttraction: 0.05,
            friction: 0.35,
            contain: true,
            cellAlign: 'left',
            cellSelector: '.product__slide--is-visible',
            initialIndex: initialSlideIndex,
            draggable: false
          });
        }
        /**
         * Initialise flickity slider
         */

      };

    },


    /**
     * If we group variant images by ALT, depending on the variant chosen, we
     * may need to rebuild our slider to show only relevant images.
     */
    updateVariantSlides: function(evt) {

      // Store variables
      var variant = evt.variant;
      var self = this;
      var rebuildSlider = false;

      /**
       * Loop over each slide
       */
      $('.product__slide').each(function(imageIndex, slide) {

        var $slide = $(slide);

        /**
         * If slide has a data attribute of the data-group-name e.g. Size, Colour
         * we run further code.
         */
        if ($slide.attr('data-group-name')) {

          // Store group name as a variable e.g. Size, Colour
          var groupName = $slide.attr('data-group-name');

          // Loop over the product options
          self.options['productOptions'].forEach(function(option, optionIndex) {

            // If the product option matches the groupName
            if (option.toLowerCase() === groupName) {

              /** 
               * If the variant value matches the slide data-group-value, e.g.
               * variant colour value is red and data-group-value is red OR
               * it is the variant featured image and matches the data-image-id
               * We add a class to SHOW the slide
               */
              if (variant['option' + (optionIndex + 1)].toLowerCase() === $slide.attr('data-group-value') || variant['featured_image'] && variant['featured_image']['id'] === parseInt($slide.attr('data-image-id'))) {
                $slide.removeClass('product__slide--is-hidden').addClass('product__slide--is-visible');
              } else {
                // Else we hide the slide
                $slide.removeClass('product__slide--is-visible').addClass('product__slide--is-hidden');
              }
            }
            
          });

          // Set rebuildSlider to true
          rebuildSlider = true;
        };
      });

      // If rebuildSlider is true, we rebuild flickity
      if (rebuildSlider) {
        // self.$productSlider.flickity('deactivate');
        // self.$productSlider.flickity('activate');
        self.destroyImageSlider();
        self.createImageSlider();
        self.$productSlider.flickity('select', 0);
      }
    },


    onSlideChange: function(evt, index) {
      var self = this;

      var $newSlide = this.$productSlider.find('.product__slide--is-visible.is-selected');

      if (!theme.config.isTouch) {
        self.initZoom($newSlide);
      };
    },


    destroyImageSlider: function() {
      if (this.$productSlider) {
        this.$productSlider.flickity('destroy');
      }
    },


    // Get slide index
    _slideIndex: function($el) {
      return $el.data('image-index');
    },


    initZoom: function($image) {

      /**
       * Defensive code to check if we already have a zoomImg
       */
      var zoomImg = $image.find('.zoomImg');

      if (zoomImg.length) {
        return;
      }

      var self = this;

      var $productImage = $image.find('.product__image');
      var zoomUrl = $productImage.attr('data-zoom-url');

      /*
       * 1. We use a `custom` zoom behaviour that's been added to the zoom.js
       *    script. This allows the user to click to zoom, and exit by either
       *    click or mouseleave events.
       * 2. Set touch to false.
       */

      $productImage.parent().zoom({
        on: 'custom', /* [1] */
        url: zoomUrl,
        duration: 180,
        magnify: self.settings.imageZoomLevel,
        touch: true, /* [2] */
        onZoomIn: function() {
          $(this).addClass('image--is-zoomed');
        },
        onZoomOut: function() {
          $(this).removeClass('image--is-zoomed');
        }
      });
    },


    destroyZoom: function(evt) {
      $('product__slide').find('.zoomImg').each(function(index, element) {
        $(element).trigger('zoom.destroy');
      });
    },


    onSelect: function() {
      theme.Modals.init();
    },

    initAccordion: function() {
      const $accordionTriggers = this.$container.find('.accordion__trigger');
      
      function animateContent($content, isExpanding) {
        const contentHeight = $content.find('.rte').outerHeight();
        
        if (isExpanding) {
          $content.removeAttr('hidden');
          $content.height(contentHeight);
        } else {
          $content.height(contentHeight);
          setTimeout(() => {
            $content.height(0);
          }, 0);
        }
      }
      
      function closeAllPanes($exceptTrigger) {
        $accordionTriggers.each(function() {
          const $trigger = $(this);
          // Skip the trigger we want to keep open
          if ($exceptTrigger && $trigger.is($exceptTrigger)) {
            return;
          }
          
          if ($trigger.attr('aria-expanded') === 'true') {
            const $content = $(`#${$trigger.attr('aria-controls')}`);
            $trigger.attr('aria-expanded', 'false');
            animateContent($content, false);
            
            // Cleanup after animation
            $content.one('transitionend', function() {
              $content.attr('hidden', '');
            });
          }
        });
      }
      
      $accordionTriggers.on('click', function(evt) {
        const $trigger = $(evt.currentTarget);
        const isExpanded = $trigger.attr('aria-expanded') === 'true';
        const contentId = $trigger.attr('aria-controls');
        const $content = $(`#${contentId}`);
        
        // If clicking an open pane, just close it
        if (isExpanded) {
          $trigger.attr('aria-expanded', 'false');
          animateContent($content, false);
          
          // Cleanup after animation
          $content.one('transitionend', function() {
            $content.attr('hidden', '');
          });
          return;
        }
        
        // Close all other panes first
        closeAllPanes($trigger);
        
        // Open the clicked pane
        $trigger.attr('aria-expanded', 'true');
        animateContent($content, true);
      });
      
      // Keyboard navigation
      $accordionTriggers.on('keydown', function(evt) {
        const $trigger = $(evt.currentTarget);
        const $allTriggers = $accordionTriggers;
        const currentIndex = $allTriggers.index($trigger);
        
        switch (evt.key) {
          case 'ArrowDown':
          case 'Down':
            evt.preventDefault();
            if (currentIndex < $allTriggers.length - 1) {
              $allTriggers.eq(currentIndex + 1).focus();
            }
            break;
            
          case 'ArrowUp':
          case 'Up':
            evt.preventDefault();
            if (currentIndex > 0) {
              $allTriggers.eq(currentIndex - 1).focus();
            }
            break;
            
          case 'Home':
            evt.preventDefault();
            $allTriggers.first().focus();
            break;
            
          case 'End':
            evt.preventDefault();
            $allTriggers.last().focus();
            break;
            
          case 'Enter':
          case ' ':
            evt.preventDefault();
            $trigger.click();
            break;
            
          case 'Escape':
            evt.preventDefault();
            if ($trigger.attr('aria-expanded') === 'true') {
              $trigger.click();
            }
            break;
        }
      });
    },

  });

  return Product;

})();










/*==============================================================================
  #ProductRecommendations
==============================================================================*/

theme.ProductRecommendations = (function() {

  var selectors = {};

  var config = {};

  function ProductRecommendations(container) {
    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');
    
    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var self = this;

    this.loadRecommendations();

    enquire.register(theme.mq.mediumUp, {
      match: function() {
        self.destroySlider();
      }
    });

    enquire.register(theme.mq.small, {
      match: function() {
        self.initSlider();
      }
    });
  }


  ProductRecommendations.prototype = $.extend({}, ProductRecommendations.prototype, {

    loadRecommendations: function() {
      var self = this;

      var url = '/recommendations/products?section_id=product-recommendations&product_id=' + self.options['productId'] + '&limit=' + self.options['productCount'];

      $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = data;

        document.querySelector('.product-recommendations').innerHTML = tempElement.querySelector('.product-recommendations').innerHTML;

        if (theme.config.bpSmall) {
          self.initSlider();
        }
      })
      .fail(function() {
        console.log("error recommendations");
      })
      .always(function() {
        // console.log("always recommendations");
      })
    },

    initSlider: function() {
      $('.js-product-rec-slider').flickity({
        "prevNextButtons": true,
        "pageDots": false,
        "wrapAround": false,
        "contain": true,
        "cellAlign": "center",
        "watchCSS": true,
        "dragThreshold": 8,
        "groupCells": true,
        "draggable": true
      });
    },

    destroySlider: function() {
      $('.js-product-rec-slider').flickity('destroy');
    }

  });

  return ProductRecommendations;

})();










/*==============================================================================
  #CollectionSection
==============================================================================*/

theme.CollectionSection = (function() {

  var selectors = {};

  var config = {};

  function CollectionSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Flag used for filtering and sorting to ensure one action at a time
    var isLoading = this.isLoading = false;
    var newUrl = this.newUrl = '';

    // Initialise section
    this.init();
  }


  CollectionSection.prototype = $.extend({}, CollectionSection.prototype, {

    init: function() {
      this.attachListeners();

      theme.FiltersDrawer = new theme.Drawers('FiltersDrawer', 'filters');
      theme.SortDrawer = new theme.Drawers('SortDrawer', 'sort');

      // Filter variables and config
      var tags = this.tags = $('.js-filter-tag');
      var clearFilters = this.clearFilters = $('.js-clear-filters');
      var activeTag = this.activeTag = 'filter-group__item--active';
      var disabledTag = this.disabledTag = 'filter-group__item--disabled';

      // Toggle variables and config
      var $collectionToolbar = this.$collectionToolbar = $('.collection-toolbar');
      var openFiltersClass = this.openFiltersClass = 'collection-toolbar--filters-is-open';
      var $mainFilters = this.$mainFilters = $('.collection-toolbar__main-filters');

      var openSortClass = this.openSortClass = 'collection-toolbar--sort-is-open';
      var $mainSort = this.$mainSort = $('.collection-toolbar__main-sort');
    },


    attachListeners: function() {
      var self = this;

      // Filters and Sort button handlers for desktop
      $('.js-filters-btn').on('click', this.toggleFilters.bind(this));
      $('.js-sort-btn').on('click', this.toggleSort.bind(this));


      /**
       * If history.popstate is triggered we reload our content with
       * the existing url
       */
      $(window).on('popstate', function(state) {
        if (state) {
          self.reloadContent(location.href);
        }
      });


      /**
       * Filter, clear, and sort event listeners.
       */
      $('.js-filter-tag').on('click', this.filterCollection.bind(this));
      $('.js-clear-filters').on('click', this.filterCollection.bind(this));
      $('.js-sort-link').on('click', this.filterCollection.bind(this));
    },



    filterCollection: function(evt) {

      var self = this;

      // Prevent default link behaviour
      evt.preventDefault();

      var $el = $(evt.currentTarget);
      var $parent = $el.parent();
      newUrl = $el.attr('href');


      // If we are still loading a previous action, prevent any further actions
      // and prevent clicks on disabled filter tags
      /**
       * If we are loading a previous action, prevent any further actions.
       * Also, prevent clicks on disabled filter tags.
       */
      if (self.isLoading || $parent.hasClass(self.disabledTag)) {
        return;
      }

      // Set loading flag to true
      self.isLoading = true;

      if ($el.hasClass('js-sort-link')) {
        theme.SortDrawer.close();
      }

      self.prepareReload(newUrl);
    },


    prepareReload: function(newUrl) {
      var self = this;

      /**
       * Add newUrl to history using pushState
       */
      history.pushState({}, '', newUrl);

      /**
       * Add a CSS class to hook into transitions or animations when loading
       * new content
       */
      $('.js-collection-content').addClass('collection-reload');

      // Reload content
      self.reloadContent(newUrl);
    },


    reloadContent: function(url) {

      var self = this;


      /**
       * Use the Shopify Sections API to grab content from a section
       * for improved performance. We build a section URL for our
       * AJAX request. Much better than loading an entire page.
       *
       * https://help.shopify.com/en/themes/development/sections/section-rendering-api
       */
      var sectionUrl;


      /**
       * Check if url has a query string e.g. ?sort_by.
       * 1. If we have a query string, we add section_id to the end
       * 2. If no query string, we add section_id with a query string
       */

      if (url.indexOf('?') != -1) {
        sectionUrl = url + '&section_id=' + self.sectionId; /* [1] */
      } else {
        sectionUrl = url + '?sectionId=' + self.sectionId; /* [2] */ 
      }


      /**
       * AJAX function to get new collection content
       */
      $.ajax(sectionUrl, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = data;

        document.querySelector('.js-collection-content').innerHTML = tempElement.querySelector('.js-collection-content').innerHTML;

        document.querySelector('.js-drawer-filter-content').innerHTML = tempElement.querySelector('.js-drawer-filter-content').innerHTML;

        document.querySelector('.js-drawer-filter-header').innerHTML = tempElement.querySelector('.js-drawer-filter-header').innerHTML;
      })
      .fail(function() {
        console.log("Filter error");
      })
      .always(function() {

        // Set loading flag to false
        self.isLoading = false;

        // Remove unload class
        $('.js-collection-content').removeClass('collection-reload');

        // Reinit Shopify Section
        theme.reinitSection('collection-template-section');

        // Reinit all relevant JS
        self.init();
      })
    },



    toggleFilters: function() {
      var self = this;

      if (self.$collectionToolbar.hasClass(self.openFiltersClass)) {
        self.closeFilters();
      } else {
        self.openFilters();
      }
    },


    openFilters: function() {
      var self = this;

      self.closeSort();

      var filtersHeight = self.$mainFilters.prop('scrollHeight');

      self.$mainFilters.css('height', filtersHeight + 'px');

      var transitionEnded = function transitionEnded(evt) {
        if (evt.originalEvent.propertyName === 'height') {
          self.$mainFilters.css('height', 'auto');
          self.$mainFilters.off('transitionend');
        }
      }

      self.$mainFilters.on('transitionend', transitionEnded);

      self.$collectionToolbar.addClass(self.openFiltersClass);
    },


    closeFilters: function() {
      var self = this;

      var filtersHeight = self.$mainFilters.prop('scrollHeight');

      self.$mainFilters.css('height', filtersHeight + 'px');

      setTimeout(function() {
        self.$mainFilters.css('height', '0');
      }, 0);

      self.$collectionToolbar.removeClass(self.openFiltersClass);
    },


    toggleSort: function() {
      var self = this;

      if (self.$collectionToolbar.hasClass(self.openSortClass)) {
        this.closeSort();
      } else {
        this.openSort();
      }
    },


    openSort: function() {
      var self = this;

      self.closeFilters();

      var sortHeight = self.$mainSort.prop('scrollHeight');

      self.$mainSort.css('height', sortHeight + 'px');

      var transitionEnded = function transitionEnded(evt) {
        if (evt.originalEvent.propertyName === 'height') {
          self.$mainSort.css('height', 'auto');

          self.$mainSort.off('transitionend');
        }
      }

      self.$mainSort.on('transitionend', transitionEnded);

      self.$collectionToolbar.addClass(self.openSortClass);
    },


    closeSort: function() {
      var self = this;

      var sortHeight = self.$mainSort.prop('scrollHeight');

      self.$mainSort.css('height', sortHeight + 'px');

      setTimeout(function() {
        self.$mainSort.css('height', '0');
      }, 0);

      self.$collectionToolbar.removeClass(self.openSortClass);
    },

  });

  return CollectionSection;

})();










/*==============================================================================
  #SearchSection
==============================================================================*/

theme.SearchSection = (function() {

  var selectors = {};

  var config = {};

  function SearchSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    // var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    // Initialise section
    this.newSearch();
  }


  SearchSection.prototype = $.extend({}, SearchSection.prototype, {

    init: function() {
    },


    newSearch: function() {
      /**
       * Function to handle starting a new search on the Search page.
       * Separate event handlers for desktop and mobile. Desktop search opens
       * in a header dropdown while mobile search opens in menu drawer.
       */

      /**
       * On desktop
       * 1. Stop propagation to ensure click event doesn't initialise
       *    closeDropdown click event.
       * 2. Cache header search item
       * 3. Pass header search item to openDropdown function 
       */
      $('.js-new-search-desktop').on('click', function(evt) {
        evt.stopPropagation(); /* [1] */
        var $searchDropdown = $('.header-nav__item--search'); /* [2] */
        theme.HeaderNav.openDropdown($searchDropdown); /* [3] */
      });
    }
  });

  return SearchSection;

})();











/*==============================================================================
  #SlideshowSection
==============================================================================*/

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get slideshow by ID
    var slideshow = this.slideshow = '.js-slideshow--' + sectionId;

    var $slideshow = this.$slideshow = $(this.slideshow);

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var $imageContainer = $(container).find('.slideshow');

    // Load image section allows for adding classes whilst loading so we can
    // animate
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }

    this.init();
  }


  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {

    init: function() {
      
      // Store options for Flickity
      var args = {
        autoPlay: this.options['isAutoplay'] ? this.options['autoplaySpeed'] : false,
        pageDots: this.options['showDots'],
        prevNextButtons: true,
        setGallerySize: false,
        draggable: false,
        accessibility: true
      };

      this.$slideshow.flickity(args);
    },


    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    // On unload, destroy slideshow
    onUnload: function() {
      this.$slideshow.flickity('destroy');
    },

    // When working on the section, pause the slideshow if it has autoplay
    onSelect: function() {
      this.$slideshow.flickity('pausePlayer');
    },

    // When leaving the section, play the slideshow if it has autoplay
    onDeselect: function() {
      this.$slideshow.flickity('unpausePlayer');
    },

    // On block select, ignore cloned slides, go to selected slide, and pause
    // autoplay
    onBlockSelect: function(evt) {
      var $slide = $('.slide--' + evt.detail.blockId);
      var slideIndex = $slide.data('slide-index');

      // Go to selected slide, pause autoplay
      this.$slideshow.flickity('selectCell', slideIndex).flickity('pausePlayer');
    },

    // On block deselect, play slideshow if it has autoplay
    onBlockDeselect: function() {
      this.$slideshow.flickity('unpausePlayer');
    }
  });

  return SlideshowSection;
})();



/*==============================================================================
  #IconBlocksSection
==============================================================================*/


theme.IconBlocksSection = (function() {
  function IconBlocksSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var $carousel = this.$carousel = $container.find('.js-icon-blocks-carousel');
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));
    
    // Wait for images to load before initializing on mobile
    this._loadImages().then(() => {
      if ($(window).width() < 768) {
        this.init();
      }
    });

    $(window).on('resize.iconBlocks-' + sectionId, $.throttle(100, function() {
      if ($(window).width() < 768) {
        if (!this.$carousel.hasClass('flickity-enabled')) {
          this._loadImages().then(() => {
            this.init();
          });
        } else {
          // Refresh Flickity to handle any height changes
          this.$carousel.flickity('resize');
        }
      } else {
        if (this.$carousel.hasClass('flickity-enabled')) {
          this.$carousel.flickity('destroy');
        }
      }
    }.bind(this)));
  }

  IconBlocksSection.prototype = $.extend({}, IconBlocksSection.prototype, {
    _loadImages: function() {
      var $images = this.$carousel.find('img');
      var imagePromises = [];

      $images.each(function() {
        var promise = new Promise((resolve) => {
          if (this.complete) {
            resolve();
          } else {
            $(this).on('load', () => resolve());
            $(this).on('error', () => resolve()); // Handle error case too
          }
        });
        imagePromises.push(promise);
      });

      return Promise.all(imagePromises);
    },

    init: function() {
      var args = {
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: false,
        wrapAround: false,
        contain: true,
        cellSelector: '.carousel-cell',
        adaptiveHeight: true, // Enable adaptive height
        on: {
          ready: () => {
            // Force a resize after initialization
            setTimeout(() => {
              this.$carousel.flickity('resize');
            }, 100);
          }
        }
      };

      this.$carousel.flickity(args);
    },

    forceReload: function() {
      if ($(window).width() < 768) {
        this._loadImages().then(() => {
          if (this.$carousel.hasClass('flickity-enabled')) {
            this.$carousel.flickity('destroy');
          }
          this.init();
        });
      }
    },

    onUnload: function() {
      if (this.$carousel.hasClass('flickity-enabled')) {
        this.$carousel.flickity('destroy');
      }
      $(window).off('resize.iconBlocks-' + this.sectionId);
    },

    onSelect: function() {
      if (this.$carousel.hasClass('flickity-enabled')) {
        this.$carousel.flickity('resize');
      }
    },

    onDeselect: function() {
      if (this.$carousel.hasClass('flickity-enabled')) {
        this.$carousel.flickity('resize');
      }
    },

    onBlockSelect: function(evt) {
      if (this.$carousel.hasClass('flickity-enabled')) {
        var $slide = $('.carousel-cell--' + evt.detail.blockId);
        var slideIndex = $slide.index();
        this.$carousel.flickity('select', slideIndex);
      }
    }
  });

  return IconBlocksSection;
})();




/*==============================================================================
  #Experiences Section
==============================================================================*/

theme.ExperiencesSection = (function() {

  var slideCount = 0;
  var sliderIsActive = false;

  function ExperiencesSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var slider = this.slider = '.js-experiences-slider--' + sectionId;

    var $slider = $(slider);
    var defaults = this.defaults = {
      pageDots: false,
      watchCSS: true
    };

    var self = this;

    slideCount = this.options['slideCount'];

    self.init($slider, this.defaults);

  }


  ExperiencesSection.prototype = $.extend({}, ExperiencesSection.prototype, {
    onUnload: function() {
      
    },

    onBlockSelect: function(evt) {
    },

    init: function(obj, args) {
      obj.flickity(args);
      sliderIsActive = true;
    },


    destroy: function(obj) {
      obj.flickity('destroy');
      sliderIsActive = false;
    }
  });

  return ExperiencesSection;
})();










/*==============================================================================
  #Featured Products Section
==============================================================================*/

theme.FeaturedProductsSection = (function() {

  var slideCount = 0;
  var sliderIsActive = false;

  function FeaturedProductsSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var slider = this.slider = '.js-featured-products-slider--' + sectionId;

    var $slider = $(slider);
    var defaults = this.defaults = {
      pageDots: false,
      watchCSS: true
    };

    var self = this;

    slideCount = this.options['slideCount'];

    self.init($slider, this.defaults);
  }


  FeaturedProductsSection.prototype = $.extend({}, FeaturedProductsSection.prototype, {
    onUnload: function() {
      
    },

    onBlockSelect: function(evt) {
    },

    init: function(obj, args) {
      obj.flickity(args);
      sliderIsActive = true;
    },


    destroy: function(obj) {
      obj.flickity('destroy');
      sliderIsActive = false;
    }
  });

  return FeaturedProductsSection;
})();



/*==============================================================================
  #Corporate gifting Section
==============================================================================*/

theme.CorporateGiftingSection = (function() {

  var slideCount = 0;
  var sliderIsActive = false;

  function CorporateGiftingSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

// Author ***** videoplayer start *****
        const players = Array.from(document.querySelectorAll('.video-plyr')).map(p => new Plyr(p));

    // $('.video-plyr', $container).each(function() {
    //   var $el = $(this);
    //   theme.Video.init($el);
    //   theme.Video.editorLoadVideo($el.attr('id'));
    // });
    //
    // const player = new Plyr('#player');

  $(document).ready(function(){
    var video1 = document.getElementById("player");
    video1.currentTime = 0;
    $(".mute-unmute").click(function(){
         if($(this).hasClass("stop"))
         {
             var ban_video = document.getElementById("player");
             $("#player").prop('muted', true);
             $(this).removeClass("stop");
         }
         else{
             var ban_video = document.getElementById("player");
             $("#player").prop('muted', false);
             $(this).addClass("stop");
         }
     });

    $(".unmute-bt").click(function(){
      $(".unmute-bt").css("display", "none");
      $(".mute-bt").css("display", "block");
    });
    $(".mute-bt").click(function(){
      $(".unmute-bt").css("display", "block");
      $(".mute-bt").css("display", "none");
    });
      }); 


// Author ***** videoplayer ends *****
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var slider = this.slider = '.js-featured-products-slider--' + sectionId;
    var $slider = $(slider);
    var defaults = this.defaults = {
    "prevNextButtons": true,
    "pageDots": false,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center"
    };

    var self = this;

   // slideCount = this.options['slideCount'];

    self.init($slider, this.defaults);
  }


  CorporateGiftingSection.prototype = $.extend({}, CorporateGiftingSection.prototype, {
    onUnload: function() {
      
    },

    onBlockSelect: function(evt) {
    },

    init: function(obj, args) {
      obj.flickity(args);
      sliderIsActive = true;
    },


    destroy: function(obj) {
      obj.flickity('destroy');
      sliderIsActive = false;
    }
  });




  //return CorporateGiftingSection;
})();



/*==============================================================================
  #Provenance Section
==============================================================================*/

theme.ProvenanceSection = (function() {

  var slideCount = 0;
  var sliderIsActive = false;

  function ProvenanceSection(container) {
    // Store container as jQuery variable
    var $container = this.$container = $(container);
     //console(theme.config.bpSmall)
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));
    //alert(theme.config.bpSmall)
    var slider = this.slider = '.js-provenance-slider';
    var $slider = $(slider);
    var defaults = this.defaults = {
    "prevNextButtons": true,
    "pageDots": false,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center"
    };

    var self = this;

   // slideCount = this.options['slideCount'];

  enquire.register(theme.mq.small, {
    match: function() {
     self.init($slider, this.defaults);
    },

    unmatch: function() {
      self.destroy($slider, this.defaults);
    }
  });   

    
  }


  ProvenanceSection.prototype = $.extend({}, ProvenanceSection.prototype, {
    onUnload: function() {
      
    },

    onBlockSelect: function(evt) {
    },

    init: function(obj, args) {
      obj.flickity(args);
      sliderIsActive = true;
    },


    destroy: function(obj) {
      obj.flickity('destroy');
      sliderIsActive = false;
    }
  });
return ProvenanceSection;
})();






/*==============================================================================
  #FAQ Section
==============================================================================*/

theme.FaqSection = (function() {

  function FaqSection(container) {
  }

  FaqSection.prototype = $.extend({}, FaqSection.prototype, {

    /**
     * Shopify Theme Editor events
     */
    onSelect: function() {
      theme.Collapsibles.init();
    },

    onDeselect: function() {
      
    },

    onUnload: function() {
    }
  });

  return FaqSection;
})();




















/*==============================================================================
  #TEMPLATES
==============================================================================*/

/*==============================================================================
  #Customer Addresses
  - Largely based off Slate
  - Handles customer addresses functionality
==============================================================================*/

theme.customerAddresses = (function() {

  var $addressForms = $('.js-address-form');

  // If no address forms exist, we don't run the code
  if (!$addressForms.length) {
    return;
  }

  // Certain countries require province selection such as Spain, Canada, UAE
  // We use Shopify.CountryProvinceSelector to show/hide the province selector
  if (Shopify) {
    $('.js-address-country').each(function() {
      var $container = $(this);
      var countryId = $container.data('country-id');
      var provinceId = $container.data('province-id');
      var provinceContainerId = $container.data('province-container-id');

      new Shopify.CountryProvinceSelector(
        countryId,
        provinceId,
        {
          hideElement: provinceContainerId
        }
      );
    });
  }

  // Delete address event handler
  $('.js-address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();










/*==============================================================================
  #Customer Login
  - Largely based off Slate
  - Handles login / recover password form
==============================================================================*/

theme.customerLogin = (function() {

  var config = {
    recoverPasswordToggle: '.js-toggle-recover-form',
    recoverPasswordForm: '#RecoverPasswordForm'
  };

  // Check recover password form exist
  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordToggle).on('click', onShowHidePasswordForm);
  // $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();




















/*==============================================================================
  #INIT
==============================================================================*/

/**
 * Check if page URL has a hash. If so, scroll to that
 * anchor. Useful when linking to another page with a hash.
 */
theme.checkForAnchorLink = function() {
  if(window.location.hash) {
    var $el = $(window.location.hash);

    if ($el.length) {
      var top = $el.offset().top - 100;
      if (top > 0) {
        window.scroll(0, top);
      }
    }
  }
};

theme.init = function() {
  /**
   * Tab Handling
   * We use CSS to remove focus outlines on a lot of elements for aesthetic
   * reasons.
   * In order to maintain accessibility, we can recognise if a user is tabbing
   * and add an `is-tabbing` class which will allow us to add focus outlines in 
   * the CSS.
   */

  $(document.documentElement).on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      $(document.documentElement).addClass('is-tabbing');
      $(document.documentElement).off('keyup.tab');
    }
  });


  /**
   * Open external links in new tab:
   * https://shopify.dev/tutorials/customize-theme-open-external-links-in-new-browser
   */
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].relList.add('noreferrer', 'noopener');
    }
  }

  theme.checkForAnchorLink();

  /**
   * SMOOTH SCROLLING for In-page anchor links
   * Based on:
   * https://stackoverflow.com/questions/7717527/smooth-scrolling-when-clicking-an-anchor-link
   */
  $(document).on('click', 'a[href^="#"]', function(evt) {
    evt.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 150
    }, 1000);
  });



  theme.setBreakpoints();
  theme.Search.init();
  theme.DrawerPanels.init();
  theme.Cart.init();
  theme.Modals.init();
  theme.Collapsibles.init();
  theme.CustomSwitcher();

  // Initialse PLYR video
  // https://github.com/sampotts/plyr

  if (window.Plyr) {
    const player = new Plyr('#player', {
      controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'],
    });
  }
};





























/*==============================================================================
  #DOC READY
==============================================================================*/

$(document).ready(function() {

  theme.init();

  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('popup-section', theme.PopupSection);
  sections.register('cookies-section', theme.CookiesSection);
  sections.register('product-template-section', theme.Product);
  sections.register('product-recommendations-section', theme.ProductRecommendations);
  sections.register('collection-template-section', theme.CollectionSection);
  sections.register('search-template-section', theme.SearchSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('icon-blocks-section', theme.IconBlocksSection);
  sections.register('featured-products-section', theme.FeaturedProductsSection);
  sections.register('corporate-gifting-section', theme.CorporateGiftingSection);
  sections.register('provenance-section', theme.ProvenanceSection);
  sections.register('experiences-section', theme.ExperiencesSection);
  sections.register('faq-section', theme.FaqSection);


  theme.reinitSection = function(section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  }

  setTimeout(function() {
      document.querySelectorAll('.ot-accordion-layout button').forEach((event) => {
          event.addEventListener("click", function(evt) {
              evt.preventDefault();
              var attr = this.getAttribute("aria-expanded");
              var obj = this;
              if (attr == 'false') {
                  setTimeout(function() {
                      obj.setAttribute("aria-expanded", "true");
                  }, 100);
              } else {
                  setTimeout(function() {
                      obj.setAttribute("aria-expanded", "false");
                  }, 100);
              }
          });
      });
  }, 2000);

   // for tabing 
  document.addEventListener("keydown", function(event){   
     if(event.key === "Tab"){
      var hasClass = event.target.classList.contains('js-product-share-btn');
      var hasClassFilters = event.target.classList.contains('js-tab-filters');
      var hasClassFilters2 = event.target.classList.contains('icon');
      var hasClassFilters3 = event.target.classList.contains('collection-toolbar-sortby');
      var sortTab = event.target.classList.contains('js-tab-sort');
      if(hasClass) document.getElementsByClassName('js-product-share-btn')[0].click()
      if(hasClassFilters3) $(".js-sort-btn").trigger("click");
      if(sortTab) { $(".js-sort-btn").trigger("click");}
      if(hasClassFilters == true && $(".collection-toolbar--filters-is-open").length == 0){
        $(".js-filters-btn").trigger("click");
      }
    }
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });


  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'table-wrapper-overflow',
  });


  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });


  // ======= HAMPERS PRODUCT DETAILS MODEL ======
  $(document).on("click",".view_hamper_details_btn", function(){
    var product_handle = $(this).attr("data-handle");
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var desc = product.description;
      image_embed = '<div><img src="' + product.featured_image + '"></div>';
      image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
      $('.modal--hampers .qv-product-images').html(image_embed);
      $('.modal--hampers .qv-product-title').text(title);
      $('.modal--hampers .qv-product-description').html(desc);
      $(".modal--hampers").addClass("modal--is-visible");
    });
  });
  $(document).on("click",".modal--hampers .js-close-modal", function(){
    $(".modal--hampers").removeClass("modal--is-visible");
  });
  // ======= HAMPERS PRODUCT DETAILS MODEL ======
});

/* size guide modal*/
$(document).ready(function() {
    var $modal = $('#sizeGuideModal');
    var $btn = $('#sizeGuideBtn');
    var $closeBtn = $('#closeModal');

    $btn.on('click', function(event) {
      event.preventDefault(); 
      $modal.show();
    });

    $closeBtn.on('click', function() {
      $modal.hide();
    });

    $(window).on('click', function(event) {
      if ($(event.target).is($modal)) {
        $modal.hide();
      }
    });
  });
/* size guide modal*/

/*YMAL on mini cart */
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.cart-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.cart-product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

/*YMAL on mini cart */


/*ATB on mini cart */
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
      if (event.target.classList.contains('add-to-cart-btn')) {
          var variantId = event.target.getAttribute('data-variant-id');
          var quantity = event.target.getAttribute('data-quantity');

          fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                  id: variantId,
                  quantity: quantity
              })
          })
          .then(response => response.json())
          .then(data => {
              console.log('Product added to cart:', data);
          })
          .catch(error => {
              console.error('Error adding product to cart:', error);
          });
      }
  });
});
/*ATB on mini cart */

/*ATB on event PDP */
$(document).ready(function() {
  var $variantSelect = $('#variant-select');
  var $addToBagButton = $('#add-to-bag');

    function updateButtonState() {
      var selectedVariantId = $variantSelect.val();
      var isVariantSelected = selectedVariantId !== '';
      var isVariantAvailable = $variantSelect.find('option:selected').is(':not([disabled])');
      
      // Enable the button if a valid variant is selected
      if (isVariantSelected && isVariantAvailable) {
        $addToBagButton.prop('disabled', false);
      } else {
        $addToBagButton.prop('disabled', true);
      }
    }

    updateButtonState();

    $variantSelect.on('change', function() {
      updateButtonState();
  });
});
/*ATB on event PDP */

